import { jsx as Fr } from "react/jsx-runtime";
import oe, { createContext as Qn, useCallback as Ft } from "react";
import Xn from "react-markdown";
import Kn from "remark-gfm";
import es from "rehype-raw";
import { renderToString as ts } from "react-dom/server";
import { useSpeechToText as rs } from "../utilities/sound/speechToText.js";
import { useTextToSpeak as ns } from "../utilities/sound/textToSpeech.js";
function E(e) {
  for (var t = arguments.length, r = Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) r[n - 1] = arguments[n];
  if (process.env.NODE_ENV !== "production") {
    var s = cs[e], a = s ? typeof s == "function" ? s.apply(null, r) : s : "unknown error nr: " + e;
    throw Error("[Immer] " + a);
  }
  throw Error("[Immer] minified error nr: " + e + (r.length ? " " + r.map((function(i) {
    return "'" + i + "'";
  })).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function Pe(e) {
  return !!e && !!e[N];
}
function Te(e) {
  var t;
  return !!e && ((function(r) {
    if (!r || typeof r != "object") return !1;
    var n = Object.getPrototypeOf(r);
    if (n === null) return !0;
    var s = Object.hasOwnProperty.call(n, "constructor") && n.constructor;
    return s === Object || typeof s == "function" && Function.toString.call(s) === hs;
  })(e) || Array.isArray(e) || !!e[Ur] || !!(!((t = e.constructor) === null || t === void 0) && t[Ur]) || nr(e) || sr(e));
}
function xe(e, t, r) {
  r === void 0 && (r = !1), He(e) === 0 ? (r ? Object.keys : Ce)(e).forEach((function(n) {
    r && typeof n == "symbol" || t(n, e[n], e);
  })) : e.forEach((function(n, s) {
    return t(s, n, e);
  }));
}
function He(e) {
  var t = e[N];
  return t ? t.i > 3 ? t.i - 4 : t.i : Array.isArray(e) ? 1 : nr(e) ? 2 : sr(e) ? 3 : 0;
}
function Ae(e, t) {
  return He(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function ss(e, t) {
  return He(e) === 2 ? e.get(t) : e[t];
}
function Xr(e, t, r) {
  var n = He(e);
  n === 2 ? e.set(t, r) : n === 3 ? e.add(r) : e[t] = r;
}
function Kr(e, t) {
  return e === t ? e !== 0 || 1 / e == 1 / t : e != e && t != t;
}
function nr(e) {
  return fs && e instanceof Map;
}
function sr(e) {
  return ds && e instanceof Set;
}
function pe(e) {
  return e.o || e.t;
}
function ar(e) {
  if (Array.isArray(e)) return Array.prototype.slice.call(e);
  var t = tn(e);
  delete t[N];
  for (var r = Ce(t), n = 0; n < r.length; n++) {
    var s = r[n], a = t[s];
    a.writable === !1 && (a.writable = !0, a.configurable = !0), (a.get || a.set) && (t[s] = { configurable: !0, writable: !0, enumerable: a.enumerable, value: e[s] });
  }
  return Object.create(Object.getPrototypeOf(e), t);
}
function ir(e, t) {
  return t === void 0 && (t = !1), or(e) || Pe(e) || !Te(e) || (He(e) > 1 && (e.set = e.add = e.clear = e.delete = as), Object.freeze(e), t && xe(e, (function(r, n) {
    return ir(n, !0);
  }), !0)), e;
}
function as() {
  E(2);
}
function or(e) {
  return e == null || typeof e != "object" || Object.isFrozen(e);
}
function ne(e) {
  var t = qt[e];
  return t || E(18, e), t;
}
function is(e, t) {
  qt[e] || (qt[e] = t);
}
function zt() {
  return process.env.NODE_ENV === "production" || Ue || E(0), Ue;
}
function At(e, t) {
  t && (ne("Patches"), e.u = [], e.s = [], e.v = t);
}
function mt(e) {
  $t(e), e.p.forEach(os), e.p = null;
}
function $t(e) {
  e === Ue && (Ue = e.l);
}
function Ar(e) {
  return Ue = { p: [], l: Ue, h: e, m: !0, _: 0 };
}
function os(e) {
  var t = e[N];
  t.i === 0 || t.i === 1 ? t.j() : t.g = !0;
}
function Ct(e, t) {
  t._ = t.p.length;
  var r = t.p[0], n = e !== void 0 && e !== r;
  return t.h.O || ne("ES5").S(t, e, n), n ? (r[N].P && (mt(t), E(4)), Te(e) && (e = yt(t, e), t.l || _t(t, e)), t.u && ne("Patches").M(r[N].t, e, t.u, t.s)) : e = yt(t, r, []), mt(t), t.u && t.v(t.u, t.s), e !== en ? e : void 0;
}
function yt(e, t, r) {
  if (or(t)) return t;
  var n = t[N];
  if (!n) return xe(t, (function(o, l) {
    return Cr(e, n, t, o, l, r);
  }), !0), t;
  if (n.A !== e) return t;
  if (!n.P) return _t(e, n.t, !0), n.t;
  if (!n.I) {
    n.I = !0, n.A._--;
    var s = n.i === 4 || n.i === 5 ? n.o = ar(n.k) : n.o, a = s, i = !1;
    n.i === 3 && (a = new Set(s), s.clear(), i = !0), xe(a, (function(o, l) {
      return Cr(e, n, s, o, l, r, i);
    })), _t(e, s, !1), r && e.u && ne("Patches").N(n, r, e.u, e.s);
  }
  return n.o;
}
function Cr(e, t, r, n, s, a, i) {
  if (process.env.NODE_ENV !== "production" && s === r && E(5), Pe(s)) {
    var o = yt(e, s, a && t && t.i !== 3 && !Ae(t.R, n) ? a.concat(n) : void 0);
    if (Xr(r, n, o), !Pe(o)) return;
    e.m = !1;
  } else i && r.add(s);
  if (Te(s) && !or(s)) {
    if (!e.h.D && e._ < 1) return;
    yt(e, s), t && t.A.l || _t(e, s);
  }
}
function _t(e, t, r) {
  r === void 0 && (r = !1), !e.l && e.h.D && e.m && ir(t, r);
}
function Et(e, t) {
  var r = e[N];
  return (r ? pe(r) : e)[t];
}
function Er(e, t) {
  if (t in e) for (var r = Object.getPrototypeOf(e); r; ) {
    var n = Object.getOwnPropertyDescriptor(r, t);
    if (n) return n;
    r = Object.getPrototypeOf(r);
  }
}
function ve(e) {
  e.P || (e.P = !0, e.l && ve(e.l));
}
function It(e) {
  e.o || (e.o = ar(e.t));
}
function Zt(e, t, r) {
  var n = nr(t) ? ne("MapSet").F(t, r) : sr(t) ? ne("MapSet").T(t, r) : e.O ? (function(s, a) {
    var i = Array.isArray(s), o = { i: i ? 1 : 0, A: a ? a.A : zt(), P: !1, I: !1, R: {}, l: a, t: s, k: null, o: null, j: null, C: !1 }, l = o, u = Xe;
    i && (l = [o], u = Je);
    var d = Proxy.revocable(l, u), _ = d.revoke, y = d.proxy;
    return o.k = y, o.j = _, y;
  })(t, r) : ne("ES5").J(t, r);
  return (r ? r.A : zt()).p.push(n), n;
}
function us(e) {
  return Pe(e) || E(22, e), (function t(r) {
    if (!Te(r)) return r;
    var n, s = r[N], a = He(r);
    if (s) {
      if (!s.P && (s.i < 4 || !ne("ES5").K(s))) return s.t;
      s.I = !0, n = Ir(r, a), s.I = !1;
    } else n = Ir(r, a);
    return xe(n, (function(i, o) {
      s && ss(s.t, i) === o || Xr(n, i, t(o));
    })), a === 3 ? new Set(n) : n;
  })(e);
}
function Ir(e, t) {
  switch (t) {
    case 2:
      return new Map(e);
    case 3:
      return Array.from(e);
  }
  return ar(e);
}
function ls() {
  function e(i, o) {
    var l = a[i];
    return l ? l.enumerable = o : a[i] = l = { configurable: !0, enumerable: o, get: function() {
      var u = this[N];
      return process.env.NODE_ENV !== "production" && s(u), Xe.get(u, i);
    }, set: function(u) {
      var d = this[N];
      process.env.NODE_ENV !== "production" && s(d), Xe.set(d, i, u);
    } }, l;
  }
  function t(i) {
    for (var o = i.length - 1; o >= 0; o--) {
      var l = i[o][N];
      if (!l.P) switch (l.i) {
        case 5:
          n(l) && ve(l);
          break;
        case 4:
          r(l) && ve(l);
      }
    }
  }
  function r(i) {
    for (var o = i.t, l = i.k, u = Ce(l), d = u.length - 1; d >= 0; d--) {
      var _ = u[d];
      if (_ !== N) {
        var y = o[_];
        if (y === void 0 && !Ae(o, _)) return !0;
        var w = l[_], S = w && w[N];
        if (S ? S.t !== y : !Kr(w, y)) return !0;
      }
    }
    var D = !!o[N];
    return u.length !== Ce(o).length + (D ? 0 : 1);
  }
  function n(i) {
    var o = i.k;
    if (o.length !== i.t.length) return !0;
    var l = Object.getOwnPropertyDescriptor(o, o.length - 1);
    if (l && !l.get) return !0;
    for (var u = 0; u < o.length; u++) if (!o.hasOwnProperty(u)) return !0;
    return !1;
  }
  function s(i) {
    i.g && E(3, JSON.stringify(pe(i)));
  }
  var a = {};
  is("ES5", { J: function(i, o) {
    var l = Array.isArray(i), u = (function(_, y) {
      if (_) {
        for (var w = Array(y.length), S = 0; S < y.length; S++) Object.defineProperty(w, "" + S, e(S, !0));
        return w;
      }
      var D = tn(y);
      delete D[N];
      for (var H = Ce(D), A = 0; A < H.length; A++) {
        var I = H[A];
        D[I] = e(I, _ || !!D[I].enumerable);
      }
      return Object.create(Object.getPrototypeOf(y), D);
    })(l, i), d = { i: l ? 5 : 4, A: o ? o.A : zt(), P: !1, I: !1, R: {}, l: o, t: i, k: u, o: null, g: !1, C: !1 };
    return Object.defineProperty(u, N, { value: d, writable: !0 }), u;
  }, S: function(i, o, l) {
    l ? Pe(o) && o[N].A === i && t(i.p) : (i.u && (function u(d) {
      if (d && typeof d == "object") {
        var _ = d[N];
        if (_) {
          var y = _.t, w = _.k, S = _.R, D = _.i;
          if (D === 4) xe(w, (function(C) {
            C !== N && (y[C] !== void 0 || Ae(y, C) ? S[C] || u(w[C]) : (S[C] = !0, ve(_)));
          })), xe(y, (function(C) {
            w[C] !== void 0 || Ae(w, C) || (S[C] = !1, ve(_));
          }));
          else if (D === 5) {
            if (n(_) && (ve(_), S.length = !0), w.length < y.length) for (var H = w.length; H < y.length; H++) S[H] = !1;
            else for (var A = y.length; A < w.length; A++) S[A] = !0;
            for (var I = Math.min(w.length, y.length), W = 0; W < I; W++) w.hasOwnProperty(W) || (S[W] = !0), S[W] === void 0 && u(w[W]);
          }
        }
      }
    })(i.p[0]), t(i.p));
  }, K: function(i) {
    return i.i === 4 ? r(i) : n(i);
  } });
}
var jr, Ue, ur = typeof Symbol < "u" && typeof /* @__PURE__ */ Symbol("x") == "symbol", fs = typeof Map < "u", ds = typeof Set < "u", Lr = typeof Proxy < "u" && Proxy.revocable !== void 0 && typeof Reflect < "u", en = ur ? /* @__PURE__ */ Symbol.for("immer-nothing") : ((jr = {})["immer-nothing"] = !0, jr), Ur = ur ? /* @__PURE__ */ Symbol.for("immer-draftable") : "__$immer_draftable", N = ur ? /* @__PURE__ */ Symbol.for("immer-state") : "__$immer_state", cs = { 0: "Illegal state", 1: "Immer drafts cannot have computed properties", 2: "This object has been frozen and should not be mutated", 3: function(e) {
  return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
}, 4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.", 5: "Immer forbids circular references", 6: "The first or second argument to `produce` must be a function", 7: "The third argument to `produce` must be a function or undefined", 8: "First argument to `createDraft` must be a plain object, an array, or an immerable object", 9: "First argument to `finishDraft` must be a draft returned by `createDraft`", 10: "The given draft is already finalized", 11: "Object.defineProperty() cannot be used on an Immer draft", 12: "Object.setPrototypeOf() cannot be used on an Immer draft", 13: "Immer only supports deleting array indices", 14: "Immer only supports setting array indices and the 'length' property", 15: function(e) {
  return "Cannot apply patch, path doesn't resolve: " + e;
}, 16: 'Sets cannot have "replace" patches.', 17: function(e) {
  return "Unsupported patch operation: " + e;
}, 18: function(e) {
  return "The plugin for '" + e + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + e + "()` when initializing your application.";
}, 20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available", 21: function(e) {
  return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + e + "'";
}, 22: function(e) {
  return "'current' expects a draft, got: " + e;
}, 23: function(e) {
  return "'original' expects a draft, got: " + e;
}, 24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed" }, hs = "" + Object.prototype.constructor, Ce = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : Object.getOwnPropertySymbols !== void 0 ? function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : Object.getOwnPropertyNames, tn = Object.getOwnPropertyDescriptors || function(e) {
  var t = {};
  return Ce(e).forEach((function(r) {
    t[r] = Object.getOwnPropertyDescriptor(e, r);
  })), t;
}, qt = {}, Xe = { get: function(e, t) {
  if (t === N) return e;
  var r = pe(e);
  if (!Ae(r, t)) return (function(s, a, i) {
    var o, l = Er(a, i);
    return l ? "value" in l ? l.value : (o = l.get) === null || o === void 0 ? void 0 : o.call(s.k) : void 0;
  })(e, r, t);
  var n = r[t];
  return e.I || !Te(n) ? n : n === Et(e.t, t) ? (It(e), e.o[t] = Zt(e.A.h, n, e)) : n;
}, has: function(e, t) {
  return t in pe(e);
}, ownKeys: function(e) {
  return Reflect.ownKeys(pe(e));
}, set: function(e, t, r) {
  var n = Er(pe(e), t);
  if (n?.set) return n.set.call(e.k, r), !0;
  if (!e.P) {
    var s = Et(pe(e), t), a = s?.[N];
    if (a && a.t === r) return e.o[t] = r, e.R[t] = !1, !0;
    if (Kr(r, s) && (r !== void 0 || Ae(e.t, t))) return !0;
    It(e), ve(e);
  }
  return e.o[t] === r && (r !== void 0 || t in e.o) || Number.isNaN(r) && Number.isNaN(e.o[t]) || (e.o[t] = r, e.R[t] = !0), !0;
}, deleteProperty: function(e, t) {
  return Et(e.t, t) !== void 0 || t in e.t ? (e.R[t] = !1, It(e), ve(e)) : delete e.R[t], e.o && delete e.o[t], !0;
}, getOwnPropertyDescriptor: function(e, t) {
  var r = pe(e), n = Reflect.getOwnPropertyDescriptor(r, t);
  return n && { writable: !0, configurable: e.i !== 1 || t !== "length", enumerable: n.enumerable, value: r[t] };
}, defineProperty: function() {
  E(11);
}, getPrototypeOf: function(e) {
  return Object.getPrototypeOf(e.t);
}, setPrototypeOf: function() {
  E(12);
} }, Je = {};
xe(Xe, (function(e, t) {
  Je[e] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
})), Je.deleteProperty = function(e, t) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && E(13), Je.set.call(this, e, t, void 0);
}, Je.set = function(e, t, r) {
  return process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && E(14), Xe.set.call(this, e[0], t, r, e[0]);
};
var ms = (function() {
  function e(r) {
    var n = this;
    this.O = Lr, this.D = !0, this.produce = function(s, a, i) {
      if (typeof s == "function" && typeof a != "function") {
        var o = a;
        a = s;
        var l = n;
        return function(D) {
          var H = this;
          D === void 0 && (D = o);
          for (var A = arguments.length, I = Array(A > 1 ? A - 1 : 0), W = 1; W < A; W++) I[W - 1] = arguments[W];
          return l.produce(D, (function(C) {
            var B;
            return (B = a).call.apply(B, [H, C].concat(I));
          }));
        };
      }
      var u;
      if (typeof a != "function" && E(6), i !== void 0 && typeof i != "function" && E(7), Te(s)) {
        var d = Ar(n), _ = Zt(n, s, void 0), y = !0;
        try {
          u = a(_), y = !1;
        } finally {
          y ? mt(d) : $t(d);
        }
        return typeof Promise < "u" && u instanceof Promise ? u.then((function(D) {
          return At(d, i), Ct(D, d);
        }), (function(D) {
          throw mt(d), D;
        })) : (At(d, i), Ct(u, d));
      }
      if (!s || typeof s != "object") {
        if ((u = a(s)) === void 0 && (u = s), u === en && (u = void 0), n.D && ir(u, !0), i) {
          var w = [], S = [];
          ne("Patches").M(s, u, w, S), i(w, S);
        }
        return u;
      }
      E(21, s);
    }, this.produceWithPatches = function(s, a) {
      if (typeof s == "function") return function(u) {
        for (var d = arguments.length, _ = Array(d > 1 ? d - 1 : 0), y = 1; y < d; y++) _[y - 1] = arguments[y];
        return n.produceWithPatches(u, (function(w) {
          return s.apply(void 0, [w].concat(_));
        }));
      };
      var i, o, l = n.produce(s, a, (function(u, d) {
        i = u, o = d;
      }));
      return typeof Promise < "u" && l instanceof Promise ? l.then((function(u) {
        return [u, i, o];
      })) : [l, i, o];
    }, typeof r?.useProxies == "boolean" && this.setUseProxies(r.useProxies), typeof r?.autoFreeze == "boolean" && this.setAutoFreeze(r.autoFreeze);
  }
  var t = e.prototype;
  return t.createDraft = function(r) {
    Te(r) || E(8), Pe(r) && (r = us(r));
    var n = Ar(this), s = Zt(this, r, void 0);
    return s[N].C = !0, $t(n), s;
  }, t.finishDraft = function(r, n) {
    var s = r && r[N];
    process.env.NODE_ENV !== "production" && (s && s.C || E(9), s.I && E(10));
    var a = s.A;
    return At(a, n), Ct(void 0, a);
  }, t.setAutoFreeze = function(r) {
    this.D = r;
  }, t.setUseProxies = function(r) {
    r && !Lr && E(20), this.O = r;
  }, t.applyPatches = function(r, n) {
    var s;
    for (s = n.length - 1; s >= 0; s--) {
      var a = n[s];
      if (a.path.length === 0 && a.op === "replace") {
        r = a.value;
        break;
      }
    }
    s > -1 && (n = n.slice(s + 1));
    var i = ne("Patches").$;
    return Pe(r) ? i(r, n) : this.produce(r, (function(o) {
      return i(o, n);
    }));
  }, e;
})(), z = new ms();
z.produce;
z.produceWithPatches.bind(z);
z.setAutoFreeze.bind(z);
z.setUseProxies.bind(z);
z.applyPatches.bind(z);
z.createDraft.bind(z);
z.finishDraft.bind(z);
var rn = /* @__PURE__ */ (function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, s) {
      n.__proto__ = s;
    } || function(n, s) {
      for (var a in s) Object.prototype.hasOwnProperty.call(s, a) && (n[a] = s[a]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
})(), ys = function(e, t) {
  var r = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, n, s, a, i;
  return i = { next: o(0), throw: o(1), return: o(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function o(u) {
    return function(d) {
      return l([u, d]);
    };
  }
  function l(u) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, s && (a = u[0] & 2 ? s.return : u[0] ? s.throw || ((a = s.return) && a.call(s), 0) : s.next) && !(a = a.call(s, u[1])).done) return a;
      switch (s = 0, a && (u = [u[0] & 2, a.value]), u[0]) {
        case 0:
        case 1:
          a = u;
          break;
        case 4:
          return r.label++, { value: u[1], done: !1 };
        case 5:
          r.label++, s = u[1], u = [0];
          continue;
        case 7:
          u = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (a = r.trys, !(a = a.length > 0 && a[a.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            r = 0;
            continue;
          }
          if (u[0] === 3 && (!a || u[1] > a[0] && u[1] < a[3])) {
            r.label = u[1];
            break;
          }
          if (u[0] === 6 && r.label < a[1]) {
            r.label = a[1], a = u;
            break;
          }
          if (a && r.label < a[2]) {
            r.label = a[2], r.ops.push(u);
            break;
          }
          a[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      u = t.call(e, r);
    } catch (d) {
      u = [6, d], s = 0;
    } finally {
      n = a = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, pt = function(e, t) {
  for (var r = 0, n = t.length, s = e.length; r < n; r++, s++)
    e[s] = t[r];
  return e;
}, _s = Object.defineProperty, ps = Object.defineProperties, vs = Object.getOwnPropertyDescriptors, Hr = Object.getOwnPropertySymbols, gs = Object.prototype.hasOwnProperty, ws = Object.prototype.propertyIsEnumerable, Vr = function(e, t, r) {
  return t in e ? _s(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
}, Be = function(e, t) {
  for (var r in t || (t = {}))
    gs.call(t, r) && Vr(e, r, t[r]);
  if (Hr)
    for (var n = 0, s = Hr(t); n < s.length; n++) {
      var r = s[n];
      ws.call(t, r) && Vr(e, r, t[r]);
    }
  return e;
}, jt = function(e, t) {
  return ps(e, vs(t));
}, Ss = function(e, t, r) {
  return new Promise(function(n, s) {
    var a = function(l) {
      try {
        o(r.next(l));
      } catch (u) {
        s(u);
      }
    }, i = function(l) {
      try {
        o(r.throw(l));
      } catch (u) {
        s(u);
      }
    }, o = function(l) {
      return l.done ? n(l.value) : Promise.resolve(l.value).then(a, i);
    };
    o((r = r.apply(e, t)).next());
  });
};
function Ee(e, t) {
  function r() {
    for (var n = [], s = 0; s < arguments.length; s++)
      n[s] = arguments[s];
    if (t) {
      var a = t.apply(void 0, n);
      if (!a)
        throw new Error("prepareAction did not return an object");
      return Be(Be({
        type: e,
        payload: a.payload
      }, "meta" in a && { meta: a.meta }), "error" in a && { error: a.error });
    }
    return { type: e, payload: n[0] };
  }
  return r.toString = function() {
    return "" + e;
  }, r.type = e, r.match = function(n) {
    return n.type === e;
  }, r;
}
(function(e) {
  rn(t, e);
  function t() {
    for (var r = [], n = 0; n < arguments.length; n++)
      r[n] = arguments[n];
    var s = e.apply(this, r) || this;
    return Object.setPrototypeOf(s, t.prototype), s;
  }
  return Object.defineProperty(t, Symbol.species, {
    get: function() {
      return t;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.concat = function() {
    for (var r = [], n = 0; n < arguments.length; n++)
      r[n] = arguments[n];
    return e.prototype.concat.apply(this, r);
  }, t.prototype.prepend = function() {
    for (var r = [], n = 0; n < arguments.length; n++)
      r[n] = arguments[n];
    return r.length === 1 && Array.isArray(r[0]) ? new (t.bind.apply(t, pt([void 0], r[0].concat(this))))() : new (t.bind.apply(t, pt([void 0], r.concat(this))))();
  }, t;
})(Array);
(function(e) {
  rn(t, e);
  function t() {
    for (var r = [], n = 0; n < arguments.length; n++)
      r[n] = arguments[n];
    var s = e.apply(this, r) || this;
    return Object.setPrototypeOf(s, t.prototype), s;
  }
  return Object.defineProperty(t, Symbol.species, {
    get: function() {
      return t;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.concat = function() {
    for (var r = [], n = 0; n < arguments.length; n++)
      r[n] = arguments[n];
    return e.prototype.concat.apply(this, r);
  }, t.prototype.prepend = function() {
    for (var r = [], n = 0; n < arguments.length; n++)
      r[n] = arguments[n];
    return r.length === 1 && Array.isArray(r[0]) ? new (t.bind.apply(t, pt([void 0], r[0].concat(this))))() : new (t.bind.apply(t, pt([void 0], r.concat(this))))();
  }, t;
})(Array);
process.env.NODE_ENV;
process.env.NODE_ENV;
var ks = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW", Jt = function(e) {
  e === void 0 && (e = 21);
  for (var t = "", r = e; r--; )
    t += ks[Math.random() * 64 | 0];
  return t;
}, bs = [
  "name",
  "message",
  "stack",
  "code"
], Lt = (
  /** @class */
  /* @__PURE__ */ (function() {
    function e(t, r) {
      this.payload = t, this.meta = r;
    }
    return e;
  })()
), Gr = (
  /** @class */
  /* @__PURE__ */ (function() {
    function e(t, r) {
      this.payload = t, this.meta = r;
    }
    return e;
  })()
), Ms = function(e) {
  if (typeof e == "object" && e !== null) {
    for (var t = {}, r = 0, n = bs; r < n.length; r++) {
      var s = n[r];
      typeof e[s] == "string" && (t[s] = e[s]);
    }
    return t;
  }
  return { message: String(e) };
};
(function() {
  function e(t, r, n) {
    var s = Ee(t + "/fulfilled", function(d, _, y, w) {
      return {
        payload: d,
        meta: jt(Be({}, w || {}), {
          arg: y,
          requestId: _,
          requestStatus: "fulfilled"
        })
      };
    }), a = Ee(t + "/pending", function(d, _, y) {
      return {
        payload: void 0,
        meta: jt(Be({}, y || {}), {
          arg: _,
          requestId: d,
          requestStatus: "pending"
        })
      };
    }), i = Ee(t + "/rejected", function(d, _, y, w, S) {
      return {
        payload: w,
        error: (n && n.serializeError || Ms)(d || "Rejected"),
        meta: jt(Be({}, S || {}), {
          arg: y,
          requestId: _,
          rejectedWithValue: !!w,
          requestStatus: "rejected",
          aborted: d?.name === "AbortError",
          condition: d?.name === "ConditionError"
        })
      };
    }), o = !1, l = typeof AbortController < "u" ? AbortController : (
      /** @class */
      (function() {
        function d() {
          this.signal = {
            aborted: !1,
            addEventListener: function() {
            },
            dispatchEvent: function() {
              return !1;
            },
            onabort: function() {
            },
            removeEventListener: function() {
            },
            reason: void 0,
            throwIfAborted: function() {
            }
          };
        }
        return d.prototype.abort = function() {
          process.env.NODE_ENV !== "production" && (o || (o = !0, console.info("This platform does not implement AbortController. \nIf you want to use the AbortController to react to `abort` events, please consider importing a polyfill like 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only'.")));
        }, d;
      })()
    );
    function u(d) {
      return function(_, y, w) {
        var S = n?.idGenerator ? n.idGenerator(d) : Jt(), D = new l(), H;
        function A(W) {
          H = W, D.abort();
        }
        var I = (function() {
          return Ss(this, null, function() {
            var W, C, B, ke, be, Me, ot;
            return ys(this, function(T) {
              switch (T.label) {
                case 0:
                  return T.trys.push([0, 4, , 5]), ke = (W = n?.condition) == null ? void 0 : W.call(n, d, { getState: y, extra: w }), Ds(ke) ? [4, ke] : [3, 2];
                case 1:
                  ke = T.sent(), T.label = 2;
                case 2:
                  if (ke === !1 || D.signal.aborted)
                    throw {
                      name: "ConditionError",
                      message: "Aborted due to condition callback returning false."
                    };
                  return be = new Promise(function(O, j) {
                    return D.signal.addEventListener("abort", function() {
                      return j({
                        name: "AbortError",
                        message: H || "Aborted"
                      });
                    });
                  }), _(a(S, d, (C = n?.getPendingMeta) == null ? void 0 : C.call(n, { requestId: S, arg: d }, { getState: y, extra: w }))), [4, Promise.race([
                    be,
                    Promise.resolve(r(d, {
                      dispatch: _,
                      getState: y,
                      extra: w,
                      requestId: S,
                      signal: D.signal,
                      abort: A,
                      rejectWithValue: function(O, j) {
                        return new Lt(O, j);
                      },
                      fulfillWithValue: function(O, j) {
                        return new Gr(O, j);
                      }
                    })).then(function(O) {
                      if (O instanceof Lt)
                        throw O;
                      return O instanceof Gr ? s(O.payload, S, d, O.meta) : s(O, S, d);
                    })
                  ])];
                case 3:
                  return B = T.sent(), [3, 5];
                case 4:
                  return Me = T.sent(), B = Me instanceof Lt ? i(null, S, d, Me.payload, Me.meta) : i(Me, S, d), [3, 5];
                case 5:
                  return ot = n && !n.dispatchConditionRejection && i.match(B) && B.meta.condition, ot || _(B), [2, B];
              }
            });
          });
        })();
        return Object.assign(I, {
          abort: A,
          requestId: S,
          arg: d,
          unwrap: function() {
            return I.then(Os);
          }
        });
      };
    }
    return Object.assign(u, {
      pending: a,
      rejected: i,
      fulfilled: s,
      typePrefix: t
    });
  }
  return e.withTypes = function() {
    return e;
  }, e;
})();
function Os(e) {
  if (e.meta && e.meta.rejectedWithValue)
    throw e.payload;
  if (e.error)
    throw e.error;
  return e.payload;
}
function Ds(e) {
  return e !== null && typeof e == "object" && typeof e.then == "function";
}
var lr = "listenerMiddleware";
Ee(lr + "/add");
Ee(lr + "/removeAll");
Ee(lr + "/remove");
var zr;
typeof queueMicrotask == "function" && queueMicrotask.bind(typeof window < "u" ? window : typeof global < "u" ? global : globalThis);
ls();
var nn;
function c() {
  return nn.apply(null, arguments);
}
function Ys(e) {
  nn = e;
}
function X(e) {
  return e instanceof Array || Object.prototype.toString.call(e) === "[object Array]";
}
function Ye(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Object]";
}
function k(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function fr(e) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(e).length === 0;
  var t;
  for (t in e)
    if (k(e, t))
      return !1;
  return !0;
}
function G(e) {
  return e === void 0;
}
function me(e) {
  return typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]";
}
function nt(e) {
  return e instanceof Date || Object.prototype.toString.call(e) === "[object Date]";
}
function sn(e, t) {
  var r = [], n, s = e.length;
  for (n = 0; n < s; ++n)
    r.push(t(e[n], n));
  return r;
}
function ge(e, t) {
  for (var r in t)
    k(t, r) && (e[r] = t[r]);
  return k(t, "toString") && (e.toString = t.toString), k(t, "valueOf") && (e.valueOf = t.valueOf), e;
}
function ae(e, t, r, n) {
  return Pn(e, t, r, n, !0).utc();
}
function Ps() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function p(e) {
  return e._pf == null && (e._pf = Ps()), e._pf;
}
var Bt;
Array.prototype.some ? Bt = Array.prototype.some : Bt = function(e) {
  var t = Object(this), r = t.length >>> 0, n;
  for (n = 0; n < r; n++)
    if (n in t && e.call(this, t[n], n, t))
      return !0;
  return !1;
};
function dr(e) {
  var t = null, r = !1, n = e._d && !isNaN(e._d.getTime());
  if (n && (t = p(e), r = Bt.call(t.parsedDateParts, function(s) {
    return s != null;
  }), n = t.overflow < 0 && !t.empty && !t.invalidEra && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && r), e._strict && (n = n && t.charsLeftOver === 0 && t.unusedTokens.length === 0 && t.bigHour === void 0)), Object.isFrozen == null || !Object.isFrozen(e))
    e._isValid = n;
  else
    return n;
  return e._isValid;
}
function bt(e) {
  var t = ae(NaN);
  return e != null ? ge(p(t), e) : p(t).userInvalidated = !0, t;
}
var $r = c.momentProperties = [], Ut = !1;
function cr(e, t) {
  var r, n, s, a = $r.length;
  if (G(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), G(t._i) || (e._i = t._i), G(t._f) || (e._f = t._f), G(t._l) || (e._l = t._l), G(t._strict) || (e._strict = t._strict), G(t._tzm) || (e._tzm = t._tzm), G(t._isUTC) || (e._isUTC = t._isUTC), G(t._offset) || (e._offset = t._offset), G(t._pf) || (e._pf = p(t)), G(t._locale) || (e._locale = t._locale), a > 0)
    for (r = 0; r < a; r++)
      n = $r[r], s = t[n], G(s) || (e[n] = s);
  return e;
}
function st(e) {
  cr(this, e), this._d = new Date(e._d != null ? e._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), Ut === !1 && (Ut = !0, c.updateOffset(this), Ut = !1);
}
function K(e) {
  return e instanceof st || e != null && e._isAMomentObject != null;
}
function an(e) {
  c.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + e);
}
function q(e, t) {
  var r = !0;
  return ge(function() {
    if (c.deprecationHandler != null && c.deprecationHandler(null, e), r) {
      var n = [], s, a, i, o = arguments.length;
      for (a = 0; a < o; a++) {
        if (s = "", typeof arguments[a] == "object") {
          s += `
[` + a + "] ";
          for (i in arguments[0])
            k(arguments[0], i) && (s += i + ": " + arguments[0][i] + ", ");
          s = s.slice(0, -2);
        } else
          s = arguments[a];
        n.push(s);
      }
      an(
        e + `
Arguments: ` + Array.prototype.slice.call(n).join("") + `
` + new Error().stack
      ), r = !1;
    }
    return t.apply(this, arguments);
  }, t);
}
var Zr = {};
function on(e, t) {
  c.deprecationHandler != null && c.deprecationHandler(e, t), Zr[e] || (an(t), Zr[e] = !0);
}
c.suppressDeprecationWarnings = !1;
c.deprecationHandler = null;
function ie(e) {
  return typeof Function < "u" && e instanceof Function || Object.prototype.toString.call(e) === "[object Function]";
}
function Ts(e) {
  var t, r;
  for (r in e)
    k(e, r) && (t = e[r], ie(t) ? this[r] = t : this["_" + r] = t);
  this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function Qt(e, t) {
  var r = ge({}, e), n;
  for (n in t)
    k(t, n) && (Ye(e[n]) && Ye(t[n]) ? (r[n] = {}, ge(r[n], e[n]), ge(r[n], t[n])) : t[n] != null ? r[n] = t[n] : delete r[n]);
  for (n in e)
    k(e, n) && !k(t, n) && Ye(e[n]) && (r[n] = ge({}, r[n]));
  return r;
}
function hr(e) {
  e != null && this.set(e);
}
var Xt;
Object.keys ? Xt = Object.keys : Xt = function(e) {
  var t, r = [];
  for (t in e)
    k(e, t) && r.push(t);
  return r;
};
var xs = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function Ns(e, t, r) {
  var n = this._calendar[e] || this._calendar.sameElse;
  return ie(n) ? n.call(t, r) : n;
}
function se(e, t, r) {
  var n = "" + Math.abs(e), s = t - n.length, a = e >= 0;
  return (a ? r ? "+" : "" : "-") + Math.pow(10, Math.max(0, s)).toString().substr(1) + n;
}
var mr = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, lt = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, Ht = {}, Ie = {};
function m(e, t, r, n) {
  var s = n;
  typeof n == "string" && (s = function() {
    return this[n]();
  }), e && (Ie[e] = s), t && (Ie[t[0]] = function() {
    return se(s.apply(this, arguments), t[1], t[2]);
  }), r && (Ie[r] = function() {
    return this.localeData().ordinal(
      s.apply(this, arguments),
      e
    );
  });
}
function Rs(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
}
function Ws(e) {
  var t = e.match(mr), r, n;
  for (r = 0, n = t.length; r < n; r++)
    Ie[t[r]] ? t[r] = Ie[t[r]] : t[r] = Rs(t[r]);
  return function(s) {
    var a = "", i;
    for (i = 0; i < n; i++)
      a += ie(t[i]) ? t[i].call(s, e) : t[i];
    return a;
  };
}
function dt(e, t) {
  return e.isValid() ? (t = un(t, e.localeData()), Ht[t] = Ht[t] || Ws(t), Ht[t](e)) : e.localeData().invalidDate();
}
function un(e, t) {
  var r = 5;
  function n(s) {
    return t.longDateFormat(s) || s;
  }
  for (lt.lastIndex = 0; r >= 0 && lt.test(e); )
    e = e.replace(
      lt,
      n
    ), lt.lastIndex = 0, r -= 1;
  return e;
}
var Fs = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function As(e) {
  var t = this._longDateFormat[e], r = this._longDateFormat[e.toUpperCase()];
  return t || !r ? t : (this._longDateFormat[e] = r.match(mr).map(function(n) {
    return n === "MMMM" || n === "MM" || n === "DD" || n === "dddd" ? n.slice(1) : n;
  }).join(""), this._longDateFormat[e]);
}
var Cs = "Invalid date";
function Es() {
  return this._invalidDate;
}
var Is = "%d", js = /\d{1,2}/;
function Ls(e) {
  return this._ordinal.replace("%d", e);
}
var Us = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function Hs(e, t, r, n) {
  var s = this._relativeTime[r];
  return ie(s) ? s(e, t, r, n) : s.replace(/%d/i, e);
}
function Vs(e, t) {
  var r = this._relativeTime[e > 0 ? "future" : "past"];
  return ie(r) ? r(t) : r.replace(/%s/i, t);
}
var qr = {
  D: "date",
  dates: "date",
  date: "date",
  d: "day",
  days: "day",
  day: "day",
  e: "weekday",
  weekdays: "weekday",
  weekday: "weekday",
  E: "isoWeekday",
  isoweekdays: "isoWeekday",
  isoweekday: "isoWeekday",
  DDD: "dayOfYear",
  dayofyears: "dayOfYear",
  dayofyear: "dayOfYear",
  h: "hour",
  hours: "hour",
  hour: "hour",
  ms: "millisecond",
  milliseconds: "millisecond",
  millisecond: "millisecond",
  m: "minute",
  minutes: "minute",
  minute: "minute",
  M: "month",
  months: "month",
  month: "month",
  Q: "quarter",
  quarters: "quarter",
  quarter: "quarter",
  s: "second",
  seconds: "second",
  second: "second",
  gg: "weekYear",
  weekyears: "weekYear",
  weekyear: "weekYear",
  GG: "isoWeekYear",
  isoweekyears: "isoWeekYear",
  isoweekyear: "isoWeekYear",
  w: "week",
  weeks: "week",
  week: "week",
  W: "isoWeek",
  isoweeks: "isoWeek",
  isoweek: "isoWeek",
  y: "year",
  years: "year",
  year: "year"
};
function J(e) {
  return typeof e == "string" ? qr[e] || qr[e.toLowerCase()] : void 0;
}
function yr(e) {
  var t = {}, r, n;
  for (n in e)
    k(e, n) && (r = J(n), r && (t[r] = e[n]));
  return t;
}
var Gs = {
  date: 9,
  day: 11,
  weekday: 11,
  isoWeekday: 11,
  dayOfYear: 4,
  hour: 13,
  millisecond: 16,
  minute: 14,
  month: 8,
  quarter: 7,
  second: 15,
  weekYear: 1,
  isoWeekYear: 1,
  week: 5,
  isoWeek: 5,
  year: 1
};
function zs(e) {
  var t = [], r;
  for (r in e)
    k(e, r) && t.push({ unit: r, priority: Gs[r] });
  return t.sort(function(n, s) {
    return n.priority - s.priority;
  }), t;
}
var ln = /\d/, $ = /\d\d/, fn = /\d{3}/, _r = /\d{4}/, Mt = /[+-]?\d{6}/, P = /\d\d?/, dn = /\d\d\d\d?/, cn = /\d\d\d\d\d\d?/, Ot = /\d{1,3}/, pr = /\d{1,4}/, Dt = /[+-]?\d{1,6}/, Ve = /\d+/, Yt = /[+-]?\d+/, $s = /Z|[+-]\d\d:?\d\d/gi, Pt = /Z|[+-]\d\d(?::?\d\d)?/gi, Zs = /[+-]?\d+(\.\d{1,3})?/, at = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, Ge = /^[1-9]\d?/, vr = /^([1-9]\d|\d)/, vt;
vt = {};
function h(e, t, r) {
  vt[e] = ie(t) ? t : function(n, s) {
    return n && r ? r : t;
  };
}
function qs(e, t) {
  return k(vt, e) ? vt[e](t._strict, t._locale) : new RegExp(Js(e));
}
function Js(e) {
  return ce(
    e.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(t, r, n, s, a) {
        return r || n || s || a;
      }
    )
  );
}
function ce(e) {
  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function Z(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}
function v(e) {
  var t = +e, r = 0;
  return t !== 0 && isFinite(t) && (r = Z(t)), r;
}
var Kt = {};
function M(e, t) {
  var r, n = t, s;
  for (typeof e == "string" && (e = [e]), me(t) && (n = function(a, i) {
    i[t] = v(a);
  }), s = e.length, r = 0; r < s; r++)
    Kt[e[r]] = n;
}
function it(e, t) {
  M(e, function(r, n, s, a) {
    s._w = s._w || {}, t(r, s._w, s, a);
  });
}
function Bs(e, t, r) {
  t != null && k(Kt, e) && Kt[e](t, r._a, r, e);
}
function Tt(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
var U = 0, fe = 1, re = 2, F = 3, Q = 4, de = 5, De = 6, Qs = 7, Xs = 8;
m("Y", 0, 0, function() {
  var e = this.year();
  return e <= 9999 ? se(e, 4) : "+" + e;
});
m(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
m(0, ["YYYY", 4], 0, "year");
m(0, ["YYYYY", 5], 0, "year");
m(0, ["YYYYYY", 6, !0], 0, "year");
h("Y", Yt);
h("YY", P, $);
h("YYYY", pr, _r);
h("YYYYY", Dt, Mt);
h("YYYYYY", Dt, Mt);
M(["YYYYY", "YYYYYY"], U);
M("YYYY", function(e, t) {
  t[U] = e.length === 2 ? c.parseTwoDigitYear(e) : v(e);
});
M("YY", function(e, t) {
  t[U] = c.parseTwoDigitYear(e);
});
M("Y", function(e, t) {
  t[U] = parseInt(e, 10);
});
function Qe(e) {
  return Tt(e) ? 366 : 365;
}
c.parseTwoDigitYear = function(e) {
  return v(e) + (v(e) > 68 ? 1900 : 2e3);
};
var hn = ze("FullYear", !0);
function Ks() {
  return Tt(this.year());
}
function ze(e, t) {
  return function(r) {
    return r != null ? (mn(this, e, r), c.updateOffset(this, t), this) : Ke(this, e);
  };
}
function Ke(e, t) {
  if (!e.isValid())
    return NaN;
  var r = e._d, n = e._isUTC;
  switch (t) {
    case "Milliseconds":
      return n ? r.getUTCMilliseconds() : r.getMilliseconds();
    case "Seconds":
      return n ? r.getUTCSeconds() : r.getSeconds();
    case "Minutes":
      return n ? r.getUTCMinutes() : r.getMinutes();
    case "Hours":
      return n ? r.getUTCHours() : r.getHours();
    case "Date":
      return n ? r.getUTCDate() : r.getDate();
    case "Day":
      return n ? r.getUTCDay() : r.getDay();
    case "Month":
      return n ? r.getUTCMonth() : r.getMonth();
    case "FullYear":
      return n ? r.getUTCFullYear() : r.getFullYear();
    default:
      return NaN;
  }
}
function mn(e, t, r) {
  var n, s, a, i, o;
  if (!(!e.isValid() || isNaN(r))) {
    switch (n = e._d, s = e._isUTC, t) {
      case "Milliseconds":
        return void (s ? n.setUTCMilliseconds(r) : n.setMilliseconds(r));
      case "Seconds":
        return void (s ? n.setUTCSeconds(r) : n.setSeconds(r));
      case "Minutes":
        return void (s ? n.setUTCMinutes(r) : n.setMinutes(r));
      case "Hours":
        return void (s ? n.setUTCHours(r) : n.setHours(r));
      case "Date":
        return void (s ? n.setUTCDate(r) : n.setDate(r));
      // case 'Day': // Not real
      //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
      // case 'Month': // Not used because we need to pass two variables
      //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
      case "FullYear":
        break;
      // See below ...
      default:
        return;
    }
    a = r, i = e.month(), o = e.date(), o = o === 29 && i === 1 && !Tt(a) ? 28 : o, s ? n.setUTCFullYear(a, i, o) : n.setFullYear(a, i, o);
  }
}
function ea(e) {
  return e = J(e), ie(this[e]) ? this[e]() : this;
}
function ta(e, t) {
  if (typeof e == "object") {
    e = yr(e);
    var r = zs(e), n, s = r.length;
    for (n = 0; n < s; n++)
      this[r[n].unit](e[r[n].unit]);
  } else if (e = J(e), ie(this[e]))
    return this[e](t);
  return this;
}
function ra(e, t) {
  return (e % t + t) % t;
}
var R;
Array.prototype.indexOf ? R = Array.prototype.indexOf : R = function(e) {
  var t;
  for (t = 0; t < this.length; ++t)
    if (this[t] === e)
      return t;
  return -1;
};
function gr(e, t) {
  if (isNaN(e) || isNaN(t))
    return NaN;
  var r = ra(t, 12);
  return e += (t - r) / 12, r === 1 ? Tt(e) ? 29 : 28 : 31 - r % 7 % 2;
}
m("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
m("MMM", 0, 0, function(e) {
  return this.localeData().monthsShort(this, e);
});
m("MMMM", 0, 0, function(e) {
  return this.localeData().months(this, e);
});
h("M", P, Ge);
h("MM", P, $);
h("MMM", function(e, t) {
  return t.monthsShortRegex(e);
});
h("MMMM", function(e, t) {
  return t.monthsRegex(e);
});
M(["M", "MM"], function(e, t) {
  t[fe] = v(e) - 1;
});
M(["MMM", "MMMM"], function(e, t, r, n) {
  var s = r._locale.monthsParse(e, n, r._strict);
  s != null ? t[fe] = s : p(r).invalidMonth = e;
});
var na = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), yn = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), _n = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, sa = at, aa = at;
function ia(e, t) {
  return e ? X(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || _n).test(t) ? "format" : "standalone"][e.month()] : X(this._months) ? this._months : this._months.standalone;
}
function oa(e, t) {
  return e ? X(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[_n.test(t) ? "format" : "standalone"][e.month()] : X(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function ua(e, t, r) {
  var n, s, a, i = e.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], n = 0; n < 12; ++n)
      a = ae([2e3, n]), this._shortMonthsParse[n] = this.monthsShort(
        a,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[n] = this.months(a, "").toLocaleLowerCase();
  return r ? t === "MMM" ? (s = R.call(this._shortMonthsParse, i), s !== -1 ? s : null) : (s = R.call(this._longMonthsParse, i), s !== -1 ? s : null) : t === "MMM" ? (s = R.call(this._shortMonthsParse, i), s !== -1 ? s : (s = R.call(this._longMonthsParse, i), s !== -1 ? s : null)) : (s = R.call(this._longMonthsParse, i), s !== -1 ? s : (s = R.call(this._shortMonthsParse, i), s !== -1 ? s : null));
}
function la(e, t, r) {
  var n, s, a;
  if (this._monthsParseExact)
    return ua.call(this, e, t, r);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), n = 0; n < 12; n++) {
    if (s = ae([2e3, n]), r && !this._longMonthsParse[n] && (this._longMonthsParse[n] = new RegExp(
      "^" + this.months(s, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[n] = new RegExp(
      "^" + this.monthsShort(s, "").replace(".", "") + "$",
      "i"
    )), !r && !this._monthsParse[n] && (a = "^" + this.months(s, "") + "|^" + this.monthsShort(s, ""), this._monthsParse[n] = new RegExp(a.replace(".", ""), "i")), r && t === "MMMM" && this._longMonthsParse[n].test(e))
      return n;
    if (r && t === "MMM" && this._shortMonthsParse[n].test(e))
      return n;
    if (!r && this._monthsParse[n].test(e))
      return n;
  }
}
function pn(e, t) {
  if (!e.isValid())
    return e;
  if (typeof t == "string") {
    if (/^\d+$/.test(t))
      t = v(t);
    else if (t = e.localeData().monthsParse(t), !me(t))
      return e;
  }
  var r = t, n = e.date();
  return n = n < 29 ? n : Math.min(n, gr(e.year(), r)), e._isUTC ? e._d.setUTCMonth(r, n) : e._d.setMonth(r, n), e;
}
function vn(e) {
  return e != null ? (pn(this, e), c.updateOffset(this, !0), this) : Ke(this, "Month");
}
function fa() {
  return gr(this.year(), this.month());
}
function da(e) {
  return this._monthsParseExact ? (k(this, "_monthsRegex") || gn.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (k(this, "_monthsShortRegex") || (this._monthsShortRegex = sa), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function ca(e) {
  return this._monthsParseExact ? (k(this, "_monthsRegex") || gn.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (k(this, "_monthsRegex") || (this._monthsRegex = aa), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
}
function gn() {
  function e(l, u) {
    return u.length - l.length;
  }
  var t = [], r = [], n = [], s, a, i, o;
  for (s = 0; s < 12; s++)
    a = ae([2e3, s]), i = ce(this.monthsShort(a, "")), o = ce(this.months(a, "")), t.push(i), r.push(o), n.push(o), n.push(i);
  t.sort(e), r.sort(e), n.sort(e), this._monthsRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function ha(e, t, r, n, s, a, i) {
  var o;
  return e < 100 && e >= 0 ? (o = new Date(e + 400, t, r, n, s, a, i), isFinite(o.getFullYear()) && o.setFullYear(e)) : o = new Date(e, t, r, n, s, a, i), o;
}
function et(e) {
  var t, r;
  return e < 100 && e >= 0 ? (r = Array.prototype.slice.call(arguments), r[0] = e + 400, t = new Date(Date.UTC.apply(null, r)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e)) : t = new Date(Date.UTC.apply(null, arguments)), t;
}
function gt(e, t, r) {
  var n = 7 + t - r, s = (7 + et(e, 0, n).getUTCDay() - t) % 7;
  return -s + n - 1;
}
function wn(e, t, r, n, s) {
  var a = (7 + r - n) % 7, i = gt(e, n, s), o = 1 + 7 * (t - 1) + a + i, l, u;
  return o <= 0 ? (l = e - 1, u = Qe(l) + o) : o > Qe(e) ? (l = e + 1, u = o - Qe(e)) : (l = e, u = o), {
    year: l,
    dayOfYear: u
  };
}
function tt(e, t, r) {
  var n = gt(e.year(), t, r), s = Math.floor((e.dayOfYear() - n - 1) / 7) + 1, a, i;
  return s < 1 ? (i = e.year() - 1, a = s + he(i, t, r)) : s > he(e.year(), t, r) ? (a = s - he(e.year(), t, r), i = e.year() + 1) : (i = e.year(), a = s), {
    week: a,
    year: i
  };
}
function he(e, t, r) {
  var n = gt(e, t, r), s = gt(e + 1, t, r);
  return (Qe(e) - n + s) / 7;
}
m("w", ["ww", 2], "wo", "week");
m("W", ["WW", 2], "Wo", "isoWeek");
h("w", P, Ge);
h("ww", P, $);
h("W", P, Ge);
h("WW", P, $);
it(
  ["w", "ww", "W", "WW"],
  function(e, t, r, n) {
    t[n.substr(0, 1)] = v(e);
  }
);
function ma(e) {
  return tt(e, this._week.dow, this._week.doy).week;
}
var ya = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function _a() {
  return this._week.dow;
}
function pa() {
  return this._week.doy;
}
function va(e) {
  var t = this.localeData().week(this);
  return e == null ? t : this.add((e - t) * 7, "d");
}
function ga(e) {
  var t = tt(this, 1, 4).week;
  return e == null ? t : this.add((e - t) * 7, "d");
}
m("d", 0, "do", "day");
m("dd", 0, 0, function(e) {
  return this.localeData().weekdaysMin(this, e);
});
m("ddd", 0, 0, function(e) {
  return this.localeData().weekdaysShort(this, e);
});
m("dddd", 0, 0, function(e) {
  return this.localeData().weekdays(this, e);
});
m("e", 0, 0, "weekday");
m("E", 0, 0, "isoWeekday");
h("d", P);
h("e", P);
h("E", P);
h("dd", function(e, t) {
  return t.weekdaysMinRegex(e);
});
h("ddd", function(e, t) {
  return t.weekdaysShortRegex(e);
});
h("dddd", function(e, t) {
  return t.weekdaysRegex(e);
});
it(["dd", "ddd", "dddd"], function(e, t, r, n) {
  var s = r._locale.weekdaysParse(e, n, r._strict);
  s != null ? t.d = s : p(r).invalidWeekday = e;
});
it(["d", "e", "E"], function(e, t, r, n) {
  t[n] = v(e);
});
function wa(e, t) {
  return typeof e != "string" ? e : isNaN(e) ? (e = t.weekdaysParse(e), typeof e == "number" ? e : null) : parseInt(e, 10);
}
function Sa(e, t) {
  return typeof e == "string" ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
}
function wr(e, t) {
  return e.slice(t, 7).concat(e.slice(0, t));
}
var ka = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), Sn = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), ba = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), Ma = at, Oa = at, Da = at;
function Ya(e, t) {
  var r = X(this._weekdays) ? this._weekdays : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
  return e === !0 ? wr(r, this._week.dow) : e ? r[e.day()] : r;
}
function Pa(e) {
  return e === !0 ? wr(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
}
function Ta(e) {
  return e === !0 ? wr(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
}
function xa(e, t, r) {
  var n, s, a, i = e.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], n = 0; n < 7; ++n)
      a = ae([2e3, 1]).day(n), this._minWeekdaysParse[n] = this.weekdaysMin(
        a,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[n] = this.weekdaysShort(
        a,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[n] = this.weekdays(a, "").toLocaleLowerCase();
  return r ? t === "dddd" ? (s = R.call(this._weekdaysParse, i), s !== -1 ? s : null) : t === "ddd" ? (s = R.call(this._shortWeekdaysParse, i), s !== -1 ? s : null) : (s = R.call(this._minWeekdaysParse, i), s !== -1 ? s : null) : t === "dddd" ? (s = R.call(this._weekdaysParse, i), s !== -1 || (s = R.call(this._shortWeekdaysParse, i), s !== -1) ? s : (s = R.call(this._minWeekdaysParse, i), s !== -1 ? s : null)) : t === "ddd" ? (s = R.call(this._shortWeekdaysParse, i), s !== -1 || (s = R.call(this._weekdaysParse, i), s !== -1) ? s : (s = R.call(this._minWeekdaysParse, i), s !== -1 ? s : null)) : (s = R.call(this._minWeekdaysParse, i), s !== -1 || (s = R.call(this._weekdaysParse, i), s !== -1) ? s : (s = R.call(this._shortWeekdaysParse, i), s !== -1 ? s : null));
}
function Na(e, t, r) {
  var n, s, a;
  if (this._weekdaysParseExact)
    return xa.call(this, e, t, r);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), n = 0; n < 7; n++) {
    if (s = ae([2e3, 1]).day(n), r && !this._fullWeekdaysParse[n] && (this._fullWeekdaysParse[n] = new RegExp(
      "^" + this.weekdays(s, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[n] = new RegExp(
      "^" + this.weekdaysShort(s, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[n] = new RegExp(
      "^" + this.weekdaysMin(s, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[n] || (a = "^" + this.weekdays(s, "") + "|^" + this.weekdaysShort(s, "") + "|^" + this.weekdaysMin(s, ""), this._weekdaysParse[n] = new RegExp(a.replace(".", ""), "i")), r && t === "dddd" && this._fullWeekdaysParse[n].test(e))
      return n;
    if (r && t === "ddd" && this._shortWeekdaysParse[n].test(e))
      return n;
    if (r && t === "dd" && this._minWeekdaysParse[n].test(e))
      return n;
    if (!r && this._weekdaysParse[n].test(e))
      return n;
  }
}
function Ra(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = Ke(this, "Day");
  return e != null ? (e = wa(e, this.localeData()), this.add(e - t, "d")) : t;
}
function Wa(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return e == null ? t : this.add(e - t, "d");
}
function Fa(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    var t = Sa(e, this.localeData());
    return this.day(this.day() % 7 ? t : t - 7);
  } else
    return this.day() || 7;
}
function Aa(e) {
  return this._weekdaysParseExact ? (k(this, "_weekdaysRegex") || Sr.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (k(this, "_weekdaysRegex") || (this._weekdaysRegex = Ma), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function Ca(e) {
  return this._weekdaysParseExact ? (k(this, "_weekdaysRegex") || Sr.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (k(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Oa), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function Ea(e) {
  return this._weekdaysParseExact ? (k(this, "_weekdaysRegex") || Sr.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (k(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = Da), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function Sr() {
  function e(d, _) {
    return _.length - d.length;
  }
  var t = [], r = [], n = [], s = [], a, i, o, l, u;
  for (a = 0; a < 7; a++)
    i = ae([2e3, 1]).day(a), o = ce(this.weekdaysMin(i, "")), l = ce(this.weekdaysShort(i, "")), u = ce(this.weekdays(i, "")), t.push(o), r.push(l), n.push(u), s.push(o), s.push(l), s.push(u);
  t.sort(e), r.sort(e), n.sort(e), s.sort(e), this._weekdaysRegex = new RegExp("^(" + s.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function kr() {
  return this.hours() % 12 || 12;
}
function Ia() {
  return this.hours() || 24;
}
m("H", ["HH", 2], 0, "hour");
m("h", ["hh", 2], 0, kr);
m("k", ["kk", 2], 0, Ia);
m("hmm", 0, 0, function() {
  return "" + kr.apply(this) + se(this.minutes(), 2);
});
m("hmmss", 0, 0, function() {
  return "" + kr.apply(this) + se(this.minutes(), 2) + se(this.seconds(), 2);
});
m("Hmm", 0, 0, function() {
  return "" + this.hours() + se(this.minutes(), 2);
});
m("Hmmss", 0, 0, function() {
  return "" + this.hours() + se(this.minutes(), 2) + se(this.seconds(), 2);
});
function kn(e, t) {
  m(e, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      t
    );
  });
}
kn("a", !0);
kn("A", !1);
function bn(e, t) {
  return t._meridiemParse;
}
h("a", bn);
h("A", bn);
h("H", P, vr);
h("h", P, Ge);
h("k", P, Ge);
h("HH", P, $);
h("hh", P, $);
h("kk", P, $);
h("hmm", dn);
h("hmmss", cn);
h("Hmm", dn);
h("Hmmss", cn);
M(["H", "HH"], F);
M(["k", "kk"], function(e, t, r) {
  var n = v(e);
  t[F] = n === 24 ? 0 : n;
});
M(["a", "A"], function(e, t, r) {
  r._isPm = r._locale.isPM(e), r._meridiem = e;
});
M(["h", "hh"], function(e, t, r) {
  t[F] = v(e), p(r).bigHour = !0;
});
M("hmm", function(e, t, r) {
  var n = e.length - 2;
  t[F] = v(e.substr(0, n)), t[Q] = v(e.substr(n)), p(r).bigHour = !0;
});
M("hmmss", function(e, t, r) {
  var n = e.length - 4, s = e.length - 2;
  t[F] = v(e.substr(0, n)), t[Q] = v(e.substr(n, 2)), t[de] = v(e.substr(s)), p(r).bigHour = !0;
});
M("Hmm", function(e, t, r) {
  var n = e.length - 2;
  t[F] = v(e.substr(0, n)), t[Q] = v(e.substr(n));
});
M("Hmmss", function(e, t, r) {
  var n = e.length - 4, s = e.length - 2;
  t[F] = v(e.substr(0, n)), t[Q] = v(e.substr(n, 2)), t[de] = v(e.substr(s));
});
function ja(e) {
  return (e + "").toLowerCase().charAt(0) === "p";
}
var La = /[ap]\.?m?\.?/i, Ua = ze("Hours", !0);
function Ha(e, t, r) {
  return e > 11 ? r ? "pm" : "PM" : r ? "am" : "AM";
}
var Mn = {
  calendar: xs,
  longDateFormat: Fs,
  invalidDate: Cs,
  ordinal: Is,
  dayOfMonthOrdinalParse: js,
  relativeTime: Us,
  months: na,
  monthsShort: yn,
  week: ya,
  weekdays: ka,
  weekdaysMin: ba,
  weekdaysShort: Sn,
  meridiemParse: La
}, x = {}, Ze = {}, rt;
function Va(e, t) {
  var r, n = Math.min(e.length, t.length);
  for (r = 0; r < n; r += 1)
    if (e[r] !== t[r])
      return r;
  return n;
}
function Jr(e) {
  return e && e.toLowerCase().replace("_", "-");
}
function Ga(e) {
  for (var t = 0, r, n, s, a; t < e.length; ) {
    for (a = Jr(e[t]).split("-"), r = a.length, n = Jr(e[t + 1]), n = n ? n.split("-") : null; r > 0; ) {
      if (s = xt(a.slice(0, r).join("-")), s)
        return s;
      if (n && n.length >= r && Va(a, n) >= r - 1)
        break;
      r--;
    }
    t++;
  }
  return rt;
}
function za(e) {
  return !!(e && e.match("^[^/\\\\]*$"));
}
function xt(e) {
  var t = null, r;
  if (x[e] === void 0 && typeof module < "u" && module && module.exports && za(e))
    try {
      t = rt._abbr, r = require, r("./locale/" + e), Se(t);
    } catch {
      x[e] = null;
    }
  return x[e];
}
function Se(e, t) {
  var r;
  return e && (G(t) ? r = ye(e) : r = br(e, t), r ? rt = r : typeof console < "u" && console.warn && console.warn(
    "Locale " + e + " not found. Did you forget to load it?"
  )), rt._abbr;
}
function br(e, t) {
  if (t !== null) {
    var r, n = Mn;
    if (t.abbr = e, x[e] != null)
      on(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), n = x[e]._config;
    else if (t.parentLocale != null)
      if (x[t.parentLocale] != null)
        n = x[t.parentLocale]._config;
      else if (r = xt(t.parentLocale), r != null)
        n = r._config;
      else
        return Ze[t.parentLocale] || (Ze[t.parentLocale] = []), Ze[t.parentLocale].push({
          name: e,
          config: t
        }), null;
    return x[e] = new hr(Qt(n, t)), Ze[e] && Ze[e].forEach(function(s) {
      br(s.name, s.config);
    }), Se(e), x[e];
  } else
    return delete x[e], null;
}
function $a(e, t) {
  if (t != null) {
    var r, n, s = Mn;
    x[e] != null && x[e].parentLocale != null ? x[e].set(Qt(x[e]._config, t)) : (n = xt(e), n != null && (s = n._config), t = Qt(s, t), n == null && (t.abbr = e), r = new hr(t), r.parentLocale = x[e], x[e] = r), Se(e);
  } else
    x[e] != null && (x[e].parentLocale != null ? (x[e] = x[e].parentLocale, e === Se() && Se(e)) : x[e] != null && delete x[e]);
  return x[e];
}
function ye(e) {
  var t;
  if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
    return rt;
  if (!X(e)) {
    if (t = xt(e), t)
      return t;
    e = [e];
  }
  return Ga(e);
}
function Za() {
  return Xt(x);
}
function Mr(e) {
  var t, r = e._a;
  return r && p(e).overflow === -2 && (t = r[fe] < 0 || r[fe] > 11 ? fe : r[re] < 1 || r[re] > gr(r[U], r[fe]) ? re : r[F] < 0 || r[F] > 24 || r[F] === 24 && (r[Q] !== 0 || r[de] !== 0 || r[De] !== 0) ? F : r[Q] < 0 || r[Q] > 59 ? Q : r[de] < 0 || r[de] > 59 ? de : r[De] < 0 || r[De] > 999 ? De : -1, p(e)._overflowDayOfYear && (t < U || t > re) && (t = re), p(e)._overflowWeeks && t === -1 && (t = Qs), p(e)._overflowWeekday && t === -1 && (t = Xs), p(e).overflow = t), e;
}
var qa = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, Ja = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, Ba = /Z|[+-]\d\d(?::?\d\d)?/, ft = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], Vt = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], Qa = /^\/?Date\((-?\d+)/i, Xa = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, Ka = {
  UT: 0,
  GMT: 0,
  EDT: -240,
  EST: -300,
  CDT: -300,
  CST: -360,
  MDT: -360,
  MST: -420,
  PDT: -420,
  PST: -480
};
function On(e) {
  var t, r, n = e._i, s = qa.exec(n) || Ja.exec(n), a, i, o, l, u = ft.length, d = Vt.length;
  if (s) {
    for (p(e).iso = !0, t = 0, r = u; t < r; t++)
      if (ft[t][1].exec(s[1])) {
        i = ft[t][0], a = ft[t][2] !== !1;
        break;
      }
    if (i == null) {
      e._isValid = !1;
      return;
    }
    if (s[3]) {
      for (t = 0, r = d; t < r; t++)
        if (Vt[t][1].exec(s[3])) {
          o = (s[2] || " ") + Vt[t][0];
          break;
        }
      if (o == null) {
        e._isValid = !1;
        return;
      }
    }
    if (!a && o != null) {
      e._isValid = !1;
      return;
    }
    if (s[4])
      if (Ba.exec(s[4]))
        l = "Z";
      else {
        e._isValid = !1;
        return;
      }
    e._f = i + (o || "") + (l || ""), Dr(e);
  } else
    e._isValid = !1;
}
function ei(e, t, r, n, s, a) {
  var i = [
    ti(e),
    yn.indexOf(t),
    parseInt(r, 10),
    parseInt(n, 10),
    parseInt(s, 10)
  ];
  return a && i.push(parseInt(a, 10)), i;
}
function ti(e) {
  var t = parseInt(e, 10);
  return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
}
function ri(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function ni(e, t, r) {
  if (e) {
    var n = Sn.indexOf(e), s = new Date(
      t[0],
      t[1],
      t[2]
    ).getDay();
    if (n !== s)
      return p(r).weekdayMismatch = !0, r._isValid = !1, !1;
  }
  return !0;
}
function si(e, t, r) {
  if (e)
    return Ka[e];
  if (t)
    return 0;
  var n = parseInt(r, 10), s = n % 100, a = (n - s) / 100;
  return a * 60 + s;
}
function Dn(e) {
  var t = Xa.exec(ri(e._i)), r;
  if (t) {
    if (r = ei(
      t[4],
      t[3],
      t[2],
      t[5],
      t[6],
      t[7]
    ), !ni(t[1], r, e))
      return;
    e._a = r, e._tzm = si(t[8], t[9], t[10]), e._d = et.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), p(e).rfc2822 = !0;
  } else
    e._isValid = !1;
}
function ai(e) {
  var t = Qa.exec(e._i);
  if (t !== null) {
    e._d = /* @__PURE__ */ new Date(+t[1]);
    return;
  }
  if (On(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  if (Dn(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  e._strict ? e._isValid = !1 : c.createFromInputFallback(e);
}
c.createFromInputFallback = q(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(e) {
    e._d = /* @__PURE__ */ new Date(e._i + (e._useUTC ? " UTC" : ""));
  }
);
function We(e, t, r) {
  return e ?? t ?? r;
}
function ii(e) {
  var t = new Date(c.now());
  return e._useUTC ? [
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate()
  ] : [t.getFullYear(), t.getMonth(), t.getDate()];
}
function Or(e) {
  var t, r, n = [], s, a, i;
  if (!e._d) {
    for (s = ii(e), e._w && e._a[re] == null && e._a[fe] == null && oi(e), e._dayOfYear != null && (i = We(e._a[U], s[U]), (e._dayOfYear > Qe(i) || e._dayOfYear === 0) && (p(e)._overflowDayOfYear = !0), r = et(i, 0, e._dayOfYear), e._a[fe] = r.getUTCMonth(), e._a[re] = r.getUTCDate()), t = 0; t < 3 && e._a[t] == null; ++t)
      e._a[t] = n[t] = s[t];
    for (; t < 7; t++)
      e._a[t] = n[t] = e._a[t] == null ? t === 2 ? 1 : 0 : e._a[t];
    e._a[F] === 24 && e._a[Q] === 0 && e._a[de] === 0 && e._a[De] === 0 && (e._nextDay = !0, e._a[F] = 0), e._d = (e._useUTC ? et : ha).apply(
      null,
      n
    ), a = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), e._tzm != null && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[F] = 24), e._w && typeof e._w.d < "u" && e._w.d !== a && (p(e).weekdayMismatch = !0);
  }
}
function oi(e) {
  var t, r, n, s, a, i, o, l, u;
  t = e._w, t.GG != null || t.W != null || t.E != null ? (a = 1, i = 4, r = We(
    t.GG,
    e._a[U],
    tt(Y(), 1, 4).year
  ), n = We(t.W, 1), s = We(t.E, 1), (s < 1 || s > 7) && (l = !0)) : (a = e._locale._week.dow, i = e._locale._week.doy, u = tt(Y(), a, i), r = We(t.gg, e._a[U], u.year), n = We(t.w, u.week), t.d != null ? (s = t.d, (s < 0 || s > 6) && (l = !0)) : t.e != null ? (s = t.e + a, (t.e < 0 || t.e > 6) && (l = !0)) : s = a), n < 1 || n > he(r, a, i) ? p(e)._overflowWeeks = !0 : l != null ? p(e)._overflowWeekday = !0 : (o = wn(r, n, s, a, i), e._a[U] = o.year, e._dayOfYear = o.dayOfYear);
}
c.ISO_8601 = function() {
};
c.RFC_2822 = function() {
};
function Dr(e) {
  if (e._f === c.ISO_8601) {
    On(e);
    return;
  }
  if (e._f === c.RFC_2822) {
    Dn(e);
    return;
  }
  e._a = [], p(e).empty = !0;
  var t = "" + e._i, r, n, s, a, i, o = t.length, l = 0, u, d;
  for (s = un(e._f, e._locale).match(mr) || [], d = s.length, r = 0; r < d; r++)
    a = s[r], n = (t.match(qs(a, e)) || [])[0], n && (i = t.substr(0, t.indexOf(n)), i.length > 0 && p(e).unusedInput.push(i), t = t.slice(
      t.indexOf(n) + n.length
    ), l += n.length), Ie[a] ? (n ? p(e).empty = !1 : p(e).unusedTokens.push(a), Bs(a, n, e)) : e._strict && !n && p(e).unusedTokens.push(a);
  p(e).charsLeftOver = o - l, t.length > 0 && p(e).unusedInput.push(t), e._a[F] <= 12 && p(e).bigHour === !0 && e._a[F] > 0 && (p(e).bigHour = void 0), p(e).parsedDateParts = e._a.slice(0), p(e).meridiem = e._meridiem, e._a[F] = ui(
    e._locale,
    e._a[F],
    e._meridiem
  ), u = p(e).era, u !== null && (e._a[U] = e._locale.erasConvertYear(u, e._a[U])), Or(e), Mr(e);
}
function ui(e, t, r) {
  var n;
  return r == null ? t : e.meridiemHour != null ? e.meridiemHour(t, r) : (e.isPM != null && (n = e.isPM(r), n && t < 12 && (t += 12), !n && t === 12 && (t = 0)), t);
}
function li(e) {
  var t, r, n, s, a, i, o = !1, l = e._f.length;
  if (l === 0) {
    p(e).invalidFormat = !0, e._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (s = 0; s < l; s++)
    a = 0, i = !1, t = cr({}, e), e._useUTC != null && (t._useUTC = e._useUTC), t._f = e._f[s], Dr(t), dr(t) && (i = !0), a += p(t).charsLeftOver, a += p(t).unusedTokens.length * 10, p(t).score = a, o ? a < n && (n = a, r = t) : (n == null || a < n || i) && (n = a, r = t, i && (o = !0));
  ge(e, r || t);
}
function fi(e) {
  if (!e._d) {
    var t = yr(e._i), r = t.day === void 0 ? t.date : t.day;
    e._a = sn(
      [t.year, t.month, r, t.hour, t.minute, t.second, t.millisecond],
      function(n) {
        return n && parseInt(n, 10);
      }
    ), Or(e);
  }
}
function di(e) {
  var t = new st(Mr(Yn(e)));
  return t._nextDay && (t.add(1, "d"), t._nextDay = void 0), t;
}
function Yn(e) {
  var t = e._i, r = e._f;
  return e._locale = e._locale || ye(e._l), t === null || r === void 0 && t === "" ? bt({ nullInput: !0 }) : (typeof t == "string" && (e._i = t = e._locale.preparse(t)), K(t) ? new st(Mr(t)) : (nt(t) ? e._d = t : X(r) ? li(e) : r ? Dr(e) : ci(e), dr(e) || (e._d = null), e));
}
function ci(e) {
  var t = e._i;
  G(t) ? e._d = new Date(c.now()) : nt(t) ? e._d = new Date(t.valueOf()) : typeof t == "string" ? ai(e) : X(t) ? (e._a = sn(t.slice(0), function(r) {
    return parseInt(r, 10);
  }), Or(e)) : Ye(t) ? fi(e) : me(t) ? e._d = new Date(t) : c.createFromInputFallback(e);
}
function Pn(e, t, r, n, s) {
  var a = {};
  return (t === !0 || t === !1) && (n = t, t = void 0), (r === !0 || r === !1) && (n = r, r = void 0), (Ye(e) && fr(e) || X(e) && e.length === 0) && (e = void 0), a._isAMomentObject = !0, a._useUTC = a._isUTC = s, a._l = r, a._i = e, a._f = t, a._strict = n, di(a);
}
function Y(e, t, r, n) {
  return Pn(e, t, r, n, !1);
}
var hi = q(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = Y.apply(null, arguments);
    return this.isValid() && e.isValid() ? e < this ? this : e : bt();
  }
), mi = q(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = Y.apply(null, arguments);
    return this.isValid() && e.isValid() ? e > this ? this : e : bt();
  }
);
function Tn(e, t) {
  var r, n;
  if (t.length === 1 && X(t[0]) && (t = t[0]), !t.length)
    return Y();
  for (r = t[0], n = 1; n < t.length; ++n)
    (!t[n].isValid() || t[n][e](r)) && (r = t[n]);
  return r;
}
function yi() {
  var e = [].slice.call(arguments, 0);
  return Tn("isBefore", e);
}
function _i() {
  var e = [].slice.call(arguments, 0);
  return Tn("isAfter", e);
}
var pi = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, qe = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function vi(e) {
  var t, r = !1, n, s = qe.length;
  for (t in e)
    if (k(e, t) && !(R.call(qe, t) !== -1 && (e[t] == null || !isNaN(e[t]))))
      return !1;
  for (n = 0; n < s; ++n)
    if (e[qe[n]]) {
      if (r)
        return !1;
      parseFloat(e[qe[n]]) !== v(e[qe[n]]) && (r = !0);
    }
  return !0;
}
function gi() {
  return this._isValid;
}
function wi() {
  return ee(NaN);
}
function Nt(e) {
  var t = yr(e), r = t.year || 0, n = t.quarter || 0, s = t.month || 0, a = t.week || t.isoWeek || 0, i = t.day || 0, o = t.hour || 0, l = t.minute || 0, u = t.second || 0, d = t.millisecond || 0;
  this._isValid = vi(t), this._milliseconds = +d + u * 1e3 + // 1000
  l * 6e4 + // 1000 * 60
  o * 1e3 * 60 * 60, this._days = +i + a * 7, this._months = +s + n * 3 + r * 12, this._data = {}, this._locale = ye(), this._bubble();
}
function ct(e) {
  return e instanceof Nt;
}
function er(e) {
  return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
}
function Si(e, t, r) {
  var n = Math.min(e.length, t.length), s = Math.abs(e.length - t.length), a = 0, i;
  for (i = 0; i < n; i++)
    v(e[i]) !== v(t[i]) && a++;
  return a + s;
}
function xn(e, t) {
  m(e, 0, 0, function() {
    var r = this.utcOffset(), n = "+";
    return r < 0 && (r = -r, n = "-"), n + se(~~(r / 60), 2) + t + se(~~r % 60, 2);
  });
}
xn("Z", ":");
xn("ZZ", "");
h("Z", Pt);
h("ZZ", Pt);
M(["Z", "ZZ"], function(e, t, r) {
  r._useUTC = !0, r._tzm = Yr(Pt, e);
});
var ki = /([\+\-]|\d\d)/gi;
function Yr(e, t) {
  var r = (t || "").match(e), n, s, a;
  return r === null ? null : (n = r[r.length - 1] || [], s = (n + "").match(ki) || ["-", 0, 0], a = +(s[1] * 60) + v(s[2]), a === 0 ? 0 : s[0] === "+" ? a : -a);
}
function Pr(e, t) {
  var r, n;
  return t._isUTC ? (r = t.clone(), n = (K(e) || nt(e) ? e.valueOf() : Y(e).valueOf()) - r.valueOf(), r._d.setTime(r._d.valueOf() + n), c.updateOffset(r, !1), r) : Y(e).local();
}
function tr(e) {
  return -Math.round(e._d.getTimezoneOffset());
}
c.updateOffset = function() {
};
function bi(e, t, r) {
  var n = this._offset || 0, s;
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    if (typeof e == "string") {
      if (e = Yr(Pt, e), e === null)
        return this;
    } else Math.abs(e) < 16 && !r && (e = e * 60);
    return !this._isUTC && t && (s = tr(this)), this._offset = e, this._isUTC = !0, s != null && this.add(s, "m"), n !== e && (!t || this._changeInProgress ? Wn(
      this,
      ee(e - n, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, c.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? n : tr(this);
}
function Mi(e, t) {
  return e != null ? (typeof e != "string" && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
}
function Oi(e) {
  return this.utcOffset(0, e);
}
function Di(e) {
  return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(tr(this), "m")), this;
}
function Yi() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var e = Yr($s, this._i);
    e != null ? this.utcOffset(e) : this.utcOffset(0, !0);
  }
  return this;
}
function Pi(e) {
  return this.isValid() ? (e = e ? Y(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0) : !1;
}
function Ti() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function xi() {
  if (!G(this._isDSTShifted))
    return this._isDSTShifted;
  var e = {}, t;
  return cr(e, this), e = Yn(e), e._a ? (t = e._isUTC ? ae(e._a) : Y(e._a), this._isDSTShifted = this.isValid() && Si(e._a, t.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function Ni() {
  return this.isValid() ? !this._isUTC : !1;
}
function Ri() {
  return this.isValid() ? this._isUTC : !1;
}
function Nn() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var Wi = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, Fi = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function ee(e, t) {
  var r = e, n = null, s, a, i;
  return ct(e) ? r = {
    ms: e._milliseconds,
    d: e._days,
    M: e._months
  } : me(e) || !isNaN(+e) ? (r = {}, t ? r[t] = +e : r.milliseconds = +e) : (n = Wi.exec(e)) ? (s = n[1] === "-" ? -1 : 1, r = {
    y: 0,
    d: v(n[re]) * s,
    h: v(n[F]) * s,
    m: v(n[Q]) * s,
    s: v(n[de]) * s,
    ms: v(er(n[De] * 1e3)) * s
    // the millisecond decimal point is included in the match
  }) : (n = Fi.exec(e)) ? (s = n[1] === "-" ? -1 : 1, r = {
    y: Oe(n[2], s),
    M: Oe(n[3], s),
    w: Oe(n[4], s),
    d: Oe(n[5], s),
    h: Oe(n[6], s),
    m: Oe(n[7], s),
    s: Oe(n[8], s)
  }) : r == null ? r = {} : typeof r == "object" && ("from" in r || "to" in r) && (i = Ai(
    Y(r.from),
    Y(r.to)
  ), r = {}, r.ms = i.milliseconds, r.M = i.months), a = new Nt(r), ct(e) && k(e, "_locale") && (a._locale = e._locale), ct(e) && k(e, "_isValid") && (a._isValid = e._isValid), a;
}
ee.fn = Nt.prototype;
ee.invalid = wi;
function Oe(e, t) {
  var r = e && parseFloat(e.replace(",", "."));
  return (isNaN(r) ? 0 : r) * t;
}
function Br(e, t) {
  var r = {};
  return r.months = t.month() - e.month() + (t.year() - e.year()) * 12, e.clone().add(r.months, "M").isAfter(t) && --r.months, r.milliseconds = +t - +e.clone().add(r.months, "M"), r;
}
function Ai(e, t) {
  var r;
  return e.isValid() && t.isValid() ? (t = Pr(t, e), e.isBefore(t) ? r = Br(e, t) : (r = Br(t, e), r.milliseconds = -r.milliseconds, r.months = -r.months), r) : { milliseconds: 0, months: 0 };
}
function Rn(e, t) {
  return function(r, n) {
    var s, a;
    return n !== null && !isNaN(+n) && (on(
      t,
      "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), a = r, r = n, n = a), s = ee(r, n), Wn(this, s, e), this;
  };
}
function Wn(e, t, r, n) {
  var s = t._milliseconds, a = er(t._days), i = er(t._months);
  e.isValid() && (n = n ?? !0, i && pn(e, Ke(e, "Month") + i * r), a && mn(e, "Date", Ke(e, "Date") + a * r), s && e._d.setTime(e._d.valueOf() + s * r), n && c.updateOffset(e, a || i));
}
var Ci = Rn(1, "add"), Ei = Rn(-1, "subtract");
function Fn(e) {
  return typeof e == "string" || e instanceof String;
}
function Ii(e) {
  return K(e) || nt(e) || Fn(e) || me(e) || Li(e) || ji(e) || e === null || e === void 0;
}
function ji(e) {
  var t = Ye(e) && !fr(e), r = !1, n = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], s, a, i = n.length;
  for (s = 0; s < i; s += 1)
    a = n[s], r = r || k(e, a);
  return t && r;
}
function Li(e) {
  var t = X(e), r = !1;
  return t && (r = e.filter(function(n) {
    return !me(n) && Fn(e);
  }).length === 0), t && r;
}
function Ui(e) {
  var t = Ye(e) && !fr(e), r = !1, n = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], s, a;
  for (s = 0; s < n.length; s += 1)
    a = n[s], r = r || k(e, a);
  return t && r;
}
function Hi(e, t) {
  var r = e.diff(t, "days", !0);
  return r < -6 ? "sameElse" : r < -1 ? "lastWeek" : r < 0 ? "lastDay" : r < 1 ? "sameDay" : r < 2 ? "nextDay" : r < 7 ? "nextWeek" : "sameElse";
}
function Vi(e, t) {
  arguments.length === 1 && (arguments[0] ? Ii(arguments[0]) ? (e = arguments[0], t = void 0) : Ui(arguments[0]) && (t = arguments[0], e = void 0) : (e = void 0, t = void 0));
  var r = e || Y(), n = Pr(r, this).startOf("day"), s = c.calendarFormat(this, n) || "sameElse", a = t && (ie(t[s]) ? t[s].call(this, r) : t[s]);
  return this.format(
    a || this.localeData().calendar(s, this, Y(r))
  );
}
function Gi() {
  return new st(this);
}
function zi(e, t) {
  var r = K(e) ? e : Y(e);
  return this.isValid() && r.isValid() ? (t = J(t) || "millisecond", t === "millisecond" ? this.valueOf() > r.valueOf() : r.valueOf() < this.clone().startOf(t).valueOf()) : !1;
}
function $i(e, t) {
  var r = K(e) ? e : Y(e);
  return this.isValid() && r.isValid() ? (t = J(t) || "millisecond", t === "millisecond" ? this.valueOf() < r.valueOf() : this.clone().endOf(t).valueOf() < r.valueOf()) : !1;
}
function Zi(e, t, r, n) {
  var s = K(e) ? e : Y(e), a = K(t) ? t : Y(t);
  return this.isValid() && s.isValid() && a.isValid() ? (n = n || "()", (n[0] === "(" ? this.isAfter(s, r) : !this.isBefore(s, r)) && (n[1] === ")" ? this.isBefore(a, r) : !this.isAfter(a, r))) : !1;
}
function qi(e, t) {
  var r = K(e) ? e : Y(e), n;
  return this.isValid() && r.isValid() ? (t = J(t) || "millisecond", t === "millisecond" ? this.valueOf() === r.valueOf() : (n = r.valueOf(), this.clone().startOf(t).valueOf() <= n && n <= this.clone().endOf(t).valueOf())) : !1;
}
function Ji(e, t) {
  return this.isSame(e, t) || this.isAfter(e, t);
}
function Bi(e, t) {
  return this.isSame(e, t) || this.isBefore(e, t);
}
function Qi(e, t, r) {
  var n, s, a;
  if (!this.isValid())
    return NaN;
  if (n = Pr(e, this), !n.isValid())
    return NaN;
  switch (s = (n.utcOffset() - this.utcOffset()) * 6e4, t = J(t), t) {
    case "year":
      a = ht(this, n) / 12;
      break;
    case "month":
      a = ht(this, n);
      break;
    case "quarter":
      a = ht(this, n) / 3;
      break;
    case "second":
      a = (this - n) / 1e3;
      break;
    // 1000
    case "minute":
      a = (this - n) / 6e4;
      break;
    // 1000 * 60
    case "hour":
      a = (this - n) / 36e5;
      break;
    // 1000 * 60 * 60
    case "day":
      a = (this - n - s) / 864e5;
      break;
    // 1000 * 60 * 60 * 24, negate dst
    case "week":
      a = (this - n - s) / 6048e5;
      break;
    // 1000 * 60 * 60 * 24 * 7, negate dst
    default:
      a = this - n;
  }
  return r ? a : Z(a);
}
function ht(e, t) {
  if (e.date() < t.date())
    return -ht(t, e);
  var r = (t.year() - e.year()) * 12 + (t.month() - e.month()), n = e.clone().add(r, "months"), s, a;
  return t - n < 0 ? (s = e.clone().add(r - 1, "months"), a = (t - n) / (n - s)) : (s = e.clone().add(r + 1, "months"), a = (t - n) / (s - n)), -(r + a) || 0;
}
c.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
c.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function Xi() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function Ki(e) {
  if (!this.isValid())
    return null;
  var t = e !== !0, r = t ? this.clone().utc() : this;
  return r.year() < 0 || r.year() > 9999 ? dt(
    r,
    t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : ie(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", dt(r, "Z")) : dt(
    r,
    t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function eo() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var e = "moment", t = "", r, n, s, a;
  return this.isLocal() || (e = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", t = "Z"), r = "[" + e + '("]', n = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", s = "-MM-DD[T]HH:mm:ss.SSS", a = t + '[")]', this.format(r + n + s + a);
}
function to(e) {
  e || (e = this.isUtc() ? c.defaultFormatUtc : c.defaultFormat);
  var t = dt(this, e);
  return this.localeData().postformat(t);
}
function ro(e, t) {
  return this.isValid() && (K(e) && e.isValid() || Y(e).isValid()) ? ee({ to: this, from: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function no(e) {
  return this.from(Y(), e);
}
function so(e, t) {
  return this.isValid() && (K(e) && e.isValid() || Y(e).isValid()) ? ee({ from: this, to: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function ao(e) {
  return this.to(Y(), e);
}
function An(e) {
  var t;
  return e === void 0 ? this._locale._abbr : (t = ye(e), t != null && (this._locale = t), this);
}
var Cn = q(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(e) {
    return e === void 0 ? this.localeData() : this.locale(e);
  }
);
function En() {
  return this._locale;
}
var wt = 1e3, je = 60 * wt, St = 60 * je, In = (365 * 400 + 97) * 24 * St;
function Le(e, t) {
  return (e % t + t) % t;
}
function jn(e, t, r) {
  return e < 100 && e >= 0 ? new Date(e + 400, t, r) - In : new Date(e, t, r).valueOf();
}
function Ln(e, t, r) {
  return e < 100 && e >= 0 ? Date.UTC(e + 400, t, r) - In : Date.UTC(e, t, r);
}
function io(e) {
  var t, r;
  if (e = J(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (r = this._isUTC ? Ln : jn, e) {
    case "year":
      t = r(this.year(), 0, 1);
      break;
    case "quarter":
      t = r(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      t = r(this.year(), this.month(), 1);
      break;
    case "week":
      t = r(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      t = r(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      t = r(this.year(), this.month(), this.date());
      break;
    case "hour":
      t = this._d.valueOf(), t -= Le(
        t + (this._isUTC ? 0 : this.utcOffset() * je),
        St
      );
      break;
    case "minute":
      t = this._d.valueOf(), t -= Le(t, je);
      break;
    case "second":
      t = this._d.valueOf(), t -= Le(t, wt);
      break;
  }
  return this._d.setTime(t), c.updateOffset(this, !0), this;
}
function oo(e) {
  var t, r;
  if (e = J(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (r = this._isUTC ? Ln : jn, e) {
    case "year":
      t = r(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      t = r(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      t = r(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      t = r(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      t = r(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      t = r(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      t = this._d.valueOf(), t += St - Le(
        t + (this._isUTC ? 0 : this.utcOffset() * je),
        St
      ) - 1;
      break;
    case "minute":
      t = this._d.valueOf(), t += je - Le(t, je) - 1;
      break;
    case "second":
      t = this._d.valueOf(), t += wt - Le(t, wt) - 1;
      break;
  }
  return this._d.setTime(t), c.updateOffset(this, !0), this;
}
function uo() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function lo() {
  return Math.floor(this.valueOf() / 1e3);
}
function fo() {
  return new Date(this.valueOf());
}
function co() {
  var e = this;
  return [
    e.year(),
    e.month(),
    e.date(),
    e.hour(),
    e.minute(),
    e.second(),
    e.millisecond()
  ];
}
function ho() {
  var e = this;
  return {
    years: e.year(),
    months: e.month(),
    date: e.date(),
    hours: e.hours(),
    minutes: e.minutes(),
    seconds: e.seconds(),
    milliseconds: e.milliseconds()
  };
}
function mo() {
  return this.isValid() ? this.toISOString() : null;
}
function yo() {
  return dr(this);
}
function _o() {
  return ge({}, p(this));
}
function po() {
  return p(this).overflow;
}
function vo() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
m("N", 0, 0, "eraAbbr");
m("NN", 0, 0, "eraAbbr");
m("NNN", 0, 0, "eraAbbr");
m("NNNN", 0, 0, "eraName");
m("NNNNN", 0, 0, "eraNarrow");
m("y", ["y", 1], "yo", "eraYear");
m("y", ["yy", 2], 0, "eraYear");
m("y", ["yyy", 3], 0, "eraYear");
m("y", ["yyyy", 4], 0, "eraYear");
h("N", Tr);
h("NN", Tr);
h("NNN", Tr);
h("NNNN", To);
h("NNNNN", xo);
M(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(e, t, r, n) {
    var s = r._locale.erasParse(e, n, r._strict);
    s ? p(r).era = s : p(r).invalidEra = e;
  }
);
h("y", Ve);
h("yy", Ve);
h("yyy", Ve);
h("yyyy", Ve);
h("yo", No);
M(["y", "yy", "yyy", "yyyy"], U);
M(["yo"], function(e, t, r, n) {
  var s;
  r._locale._eraYearOrdinalRegex && (s = e.match(r._locale._eraYearOrdinalRegex)), r._locale.eraYearOrdinalParse ? t[U] = r._locale.eraYearOrdinalParse(e, s) : t[U] = parseInt(e, 10);
});
function go(e, t) {
  var r, n, s, a = this._eras || ye("en")._eras;
  for (r = 0, n = a.length; r < n; ++r)
    switch (typeof a[r].since === "string" && (s = c(a[r].since).startOf("day"), a[r].since = s.valueOf()), typeof a[r].until) {
      case "undefined":
        a[r].until = 1 / 0;
        break;
      case "string":
        s = c(a[r].until).startOf("day").valueOf(), a[r].until = s.valueOf();
        break;
    }
  return a;
}
function wo(e, t, r) {
  var n, s, a = this.eras(), i, o, l;
  for (e = e.toUpperCase(), n = 0, s = a.length; n < s; ++n)
    if (i = a[n].name.toUpperCase(), o = a[n].abbr.toUpperCase(), l = a[n].narrow.toUpperCase(), r)
      switch (t) {
        case "N":
        case "NN":
        case "NNN":
          if (o === e)
            return a[n];
          break;
        case "NNNN":
          if (i === e)
            return a[n];
          break;
        case "NNNNN":
          if (l === e)
            return a[n];
          break;
      }
    else if ([i, o, l].indexOf(e) >= 0)
      return a[n];
}
function So(e, t) {
  var r = e.since <= e.until ? 1 : -1;
  return t === void 0 ? c(e.since).year() : c(e.since).year() + (t - e.offset) * r;
}
function ko() {
  var e, t, r, n = this.localeData().eras();
  for (e = 0, t = n.length; e < t; ++e)
    if (r = this.clone().startOf("day").valueOf(), n[e].since <= r && r <= n[e].until || n[e].until <= r && r <= n[e].since)
      return n[e].name;
  return "";
}
function bo() {
  var e, t, r, n = this.localeData().eras();
  for (e = 0, t = n.length; e < t; ++e)
    if (r = this.clone().startOf("day").valueOf(), n[e].since <= r && r <= n[e].until || n[e].until <= r && r <= n[e].since)
      return n[e].narrow;
  return "";
}
function Mo() {
  var e, t, r, n = this.localeData().eras();
  for (e = 0, t = n.length; e < t; ++e)
    if (r = this.clone().startOf("day").valueOf(), n[e].since <= r && r <= n[e].until || n[e].until <= r && r <= n[e].since)
      return n[e].abbr;
  return "";
}
function Oo() {
  var e, t, r, n, s = this.localeData().eras();
  for (e = 0, t = s.length; e < t; ++e)
    if (r = s[e].since <= s[e].until ? 1 : -1, n = this.clone().startOf("day").valueOf(), s[e].since <= n && n <= s[e].until || s[e].until <= n && n <= s[e].since)
      return (this.year() - c(s[e].since).year()) * r + s[e].offset;
  return this.year();
}
function Do(e) {
  return k(this, "_erasNameRegex") || xr.call(this), e ? this._erasNameRegex : this._erasRegex;
}
function Yo(e) {
  return k(this, "_erasAbbrRegex") || xr.call(this), e ? this._erasAbbrRegex : this._erasRegex;
}
function Po(e) {
  return k(this, "_erasNarrowRegex") || xr.call(this), e ? this._erasNarrowRegex : this._erasRegex;
}
function Tr(e, t) {
  return t.erasAbbrRegex(e);
}
function To(e, t) {
  return t.erasNameRegex(e);
}
function xo(e, t) {
  return t.erasNarrowRegex(e);
}
function No(e, t) {
  return t._eraYearOrdinalRegex || Ve;
}
function xr() {
  var e = [], t = [], r = [], n = [], s, a, i, o, l, u = this.eras();
  for (s = 0, a = u.length; s < a; ++s)
    i = ce(u[s].name), o = ce(u[s].abbr), l = ce(u[s].narrow), t.push(i), e.push(o), r.push(l), n.push(i), n.push(o), n.push(l);
  this._erasRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  );
}
m(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
m(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function Rt(e, t) {
  m(0, [e, e.length], 0, t);
}
Rt("gggg", "weekYear");
Rt("ggggg", "weekYear");
Rt("GGGG", "isoWeekYear");
Rt("GGGGG", "isoWeekYear");
h("G", Yt);
h("g", Yt);
h("GG", P, $);
h("gg", P, $);
h("GGGG", pr, _r);
h("gggg", pr, _r);
h("GGGGG", Dt, Mt);
h("ggggg", Dt, Mt);
it(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(e, t, r, n) {
    t[n.substr(0, 2)] = v(e);
  }
);
it(["gg", "GG"], function(e, t, r, n) {
  t[n] = c.parseTwoDigitYear(e);
});
function Ro(e) {
  return Un.call(
    this,
    e,
    this.week(),
    this.weekday() + this.localeData()._week.dow,
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function Wo(e) {
  return Un.call(
    this,
    e,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function Fo() {
  return he(this.year(), 1, 4);
}
function Ao() {
  return he(this.isoWeekYear(), 1, 4);
}
function Co() {
  var e = this.localeData()._week;
  return he(this.year(), e.dow, e.doy);
}
function Eo() {
  var e = this.localeData()._week;
  return he(this.weekYear(), e.dow, e.doy);
}
function Un(e, t, r, n, s) {
  var a;
  return e == null ? tt(this, n, s).year : (a = he(e, n, s), t > a && (t = a), Io.call(this, e, t, r, n, s));
}
function Io(e, t, r, n, s) {
  var a = wn(e, t, r, n, s), i = et(a.year, 0, a.dayOfYear);
  return this.year(i.getUTCFullYear()), this.month(i.getUTCMonth()), this.date(i.getUTCDate()), this;
}
m("Q", 0, "Qo", "quarter");
h("Q", ln);
M("Q", function(e, t) {
  t[fe] = (v(e) - 1) * 3;
});
function jo(e) {
  return e == null ? Math.ceil((this.month() + 1) / 3) : this.month((e - 1) * 3 + this.month() % 3);
}
m("D", ["DD", 2], "Do", "date");
h("D", P, Ge);
h("DD", P, $);
h("Do", function(e, t) {
  return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
});
M(["D", "DD"], re);
M("Do", function(e, t) {
  t[re] = v(e.match(P)[0]);
});
var Hn = ze("Date", !0);
m("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
h("DDD", Ot);
h("DDDD", fn);
M(["DDD", "DDDD"], function(e, t, r) {
  r._dayOfYear = v(e);
});
function Lo(e) {
  var t = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return e == null ? t : this.add(e - t, "d");
}
m("m", ["mm", 2], 0, "minute");
h("m", P, vr);
h("mm", P, $);
M(["m", "mm"], Q);
var Uo = ze("Minutes", !1);
m("s", ["ss", 2], 0, "second");
h("s", P, vr);
h("ss", P, $);
M(["s", "ss"], de);
var Ho = ze("Seconds", !1);
m("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
m(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
m(0, ["SSS", 3], 0, "millisecond");
m(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
m(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
m(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
m(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
m(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
m(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
h("S", Ot, ln);
h("SS", Ot, $);
h("SSS", Ot, fn);
var we, Vn;
for (we = "SSSS"; we.length <= 9; we += "S")
  h(we, Ve);
function Vo(e, t) {
  t[De] = v(("0." + e) * 1e3);
}
for (we = "S"; we.length <= 9; we += "S")
  M(we, Vo);
Vn = ze("Milliseconds", !1);
m("z", 0, 0, "zoneAbbr");
m("zz", 0, 0, "zoneName");
function Go() {
  return this._isUTC ? "UTC" : "";
}
function zo() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var f = st.prototype;
f.add = Ci;
f.calendar = Vi;
f.clone = Gi;
f.diff = Qi;
f.endOf = oo;
f.format = to;
f.from = ro;
f.fromNow = no;
f.to = so;
f.toNow = ao;
f.get = ea;
f.invalidAt = po;
f.isAfter = zi;
f.isBefore = $i;
f.isBetween = Zi;
f.isSame = qi;
f.isSameOrAfter = Ji;
f.isSameOrBefore = Bi;
f.isValid = yo;
f.lang = Cn;
f.locale = An;
f.localeData = En;
f.max = mi;
f.min = hi;
f.parsingFlags = _o;
f.set = ta;
f.startOf = io;
f.subtract = Ei;
f.toArray = co;
f.toObject = ho;
f.toDate = fo;
f.toISOString = Ki;
f.inspect = eo;
typeof Symbol < "u" && Symbol.for != null && (f[/* @__PURE__ */ Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
f.toJSON = mo;
f.toString = Xi;
f.unix = lo;
f.valueOf = uo;
f.creationData = vo;
f.eraName = ko;
f.eraNarrow = bo;
f.eraAbbr = Mo;
f.eraYear = Oo;
f.year = hn;
f.isLeapYear = Ks;
f.weekYear = Ro;
f.isoWeekYear = Wo;
f.quarter = f.quarters = jo;
f.month = vn;
f.daysInMonth = fa;
f.week = f.weeks = va;
f.isoWeek = f.isoWeeks = ga;
f.weeksInYear = Co;
f.weeksInWeekYear = Eo;
f.isoWeeksInYear = Fo;
f.isoWeeksInISOWeekYear = Ao;
f.date = Hn;
f.day = f.days = Ra;
f.weekday = Wa;
f.isoWeekday = Fa;
f.dayOfYear = Lo;
f.hour = f.hours = Ua;
f.minute = f.minutes = Uo;
f.second = f.seconds = Ho;
f.millisecond = f.milliseconds = Vn;
f.utcOffset = bi;
f.utc = Oi;
f.local = Di;
f.parseZone = Yi;
f.hasAlignedHourOffset = Pi;
f.isDST = Ti;
f.isLocal = Ni;
f.isUtcOffset = Ri;
f.isUtc = Nn;
f.isUTC = Nn;
f.zoneAbbr = Go;
f.zoneName = zo;
f.dates = q(
  "dates accessor is deprecated. Use date instead.",
  Hn
);
f.months = q(
  "months accessor is deprecated. Use month instead",
  vn
);
f.years = q(
  "years accessor is deprecated. Use year instead",
  hn
);
f.zone = q(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  Mi
);
f.isDSTShifted = q(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  xi
);
function $o(e) {
  return Y(e * 1e3);
}
function Zo() {
  return Y.apply(null, arguments).parseZone();
}
function Gn(e) {
  return e;
}
var b = hr.prototype;
b.calendar = Ns;
b.longDateFormat = As;
b.invalidDate = Es;
b.ordinal = Ls;
b.preparse = Gn;
b.postformat = Gn;
b.relativeTime = Hs;
b.pastFuture = Vs;
b.set = Ts;
b.eras = go;
b.erasParse = wo;
b.erasConvertYear = So;
b.erasAbbrRegex = Yo;
b.erasNameRegex = Do;
b.erasNarrowRegex = Po;
b.months = ia;
b.monthsShort = oa;
b.monthsParse = la;
b.monthsRegex = ca;
b.monthsShortRegex = da;
b.week = ma;
b.firstDayOfYear = pa;
b.firstDayOfWeek = _a;
b.weekdays = Ya;
b.weekdaysMin = Ta;
b.weekdaysShort = Pa;
b.weekdaysParse = Na;
b.weekdaysRegex = Aa;
b.weekdaysShortRegex = Ca;
b.weekdaysMinRegex = Ea;
b.isPM = ja;
b.meridiem = Ha;
function kt(e, t, r, n) {
  var s = ye(), a = ae().set(n, t);
  return s[r](a, e);
}
function zn(e, t, r) {
  if (me(e) && (t = e, e = void 0), e = e || "", t != null)
    return kt(e, t, r, "month");
  var n, s = [];
  for (n = 0; n < 12; n++)
    s[n] = kt(e, n, r, "month");
  return s;
}
function Nr(e, t, r, n) {
  typeof e == "boolean" ? (me(t) && (r = t, t = void 0), t = t || "") : (t = e, r = t, e = !1, me(t) && (r = t, t = void 0), t = t || "");
  var s = ye(), a = e ? s._week.dow : 0, i, o = [];
  if (r != null)
    return kt(t, (r + a) % 7, n, "day");
  for (i = 0; i < 7; i++)
    o[i] = kt(t, (i + a) % 7, n, "day");
  return o;
}
function qo(e, t) {
  return zn(e, t, "months");
}
function Jo(e, t) {
  return zn(e, t, "monthsShort");
}
function Bo(e, t, r) {
  return Nr(e, t, r, "weekdays");
}
function Qo(e, t, r) {
  return Nr(e, t, r, "weekdaysShort");
}
function Xo(e, t, r) {
  return Nr(e, t, r, "weekdaysMin");
}
Se("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(e) {
    var t = e % 10, r = v(e % 100 / 10) === 1 ? "th" : t === 1 ? "st" : t === 2 ? "nd" : t === 3 ? "rd" : "th";
    return e + r;
  }
});
c.lang = q(
  "moment.lang is deprecated. Use moment.locale instead.",
  Se
);
c.langData = q(
  "moment.langData is deprecated. Use moment.localeData instead.",
  ye
);
var ue = Math.abs;
function Ko() {
  var e = this._data;
  return this._milliseconds = ue(this._milliseconds), this._days = ue(this._days), this._months = ue(this._months), e.milliseconds = ue(e.milliseconds), e.seconds = ue(e.seconds), e.minutes = ue(e.minutes), e.hours = ue(e.hours), e.months = ue(e.months), e.years = ue(e.years), this;
}
function $n(e, t, r, n) {
  var s = ee(t, r);
  return e._milliseconds += n * s._milliseconds, e._days += n * s._days, e._months += n * s._months, e._bubble();
}
function eu(e, t) {
  return $n(this, e, t, 1);
}
function tu(e, t) {
  return $n(this, e, t, -1);
}
function Qr(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function ru() {
  var e = this._milliseconds, t = this._days, r = this._months, n = this._data, s, a, i, o, l;
  return e >= 0 && t >= 0 && r >= 0 || e <= 0 && t <= 0 && r <= 0 || (e += Qr(rr(r) + t) * 864e5, t = 0, r = 0), n.milliseconds = e % 1e3, s = Z(e / 1e3), n.seconds = s % 60, a = Z(s / 60), n.minutes = a % 60, i = Z(a / 60), n.hours = i % 24, t += Z(i / 24), l = Z(Zn(t)), r += l, t -= Qr(rr(l)), o = Z(r / 12), r %= 12, n.days = t, n.months = r, n.years = o, this;
}
function Zn(e) {
  return e * 4800 / 146097;
}
function rr(e) {
  return e * 146097 / 4800;
}
function nu(e) {
  if (!this.isValid())
    return NaN;
  var t, r, n = this._milliseconds;
  if (e = J(e), e === "month" || e === "quarter" || e === "year")
    switch (t = this._days + n / 864e5, r = this._months + Zn(t), e) {
      case "month":
        return r;
      case "quarter":
        return r / 3;
      case "year":
        return r / 12;
    }
  else
    switch (t = this._days + Math.round(rr(this._months)), e) {
      case "week":
        return t / 7 + n / 6048e5;
      case "day":
        return t + n / 864e5;
      case "hour":
        return t * 24 + n / 36e5;
      case "minute":
        return t * 1440 + n / 6e4;
      case "second":
        return t * 86400 + n / 1e3;
      // Math.floor prevents floating point math errors here
      case "millisecond":
        return Math.floor(t * 864e5) + n;
      default:
        throw new Error("Unknown unit " + e);
    }
}
function _e(e) {
  return function() {
    return this.as(e);
  };
}
var qn = _e("ms"), su = _e("s"), au = _e("m"), iu = _e("h"), ou = _e("d"), uu = _e("w"), lu = _e("M"), fu = _e("Q"), du = _e("y"), cu = qn;
function hu() {
  return ee(this);
}
function mu(e) {
  return e = J(e), this.isValid() ? this[e + "s"]() : NaN;
}
function Ne(e) {
  return function() {
    return this.isValid() ? this._data[e] : NaN;
  };
}
var yu = Ne("milliseconds"), _u = Ne("seconds"), pu = Ne("minutes"), vu = Ne("hours"), gu = Ne("days"), wu = Ne("months"), Su = Ne("years");
function ku() {
  return Z(this.days() / 7);
}
var le = Math.round, Fe = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function bu(e, t, r, n, s) {
  return s.relativeTime(t || 1, !!r, e, n);
}
function Mu(e, t, r, n) {
  var s = ee(e).abs(), a = le(s.as("s")), i = le(s.as("m")), o = le(s.as("h")), l = le(s.as("d")), u = le(s.as("M")), d = le(s.as("w")), _ = le(s.as("y")), y = a <= r.ss && ["s", a] || a < r.s && ["ss", a] || i <= 1 && ["m"] || i < r.m && ["mm", i] || o <= 1 && ["h"] || o < r.h && ["hh", o] || l <= 1 && ["d"] || l < r.d && ["dd", l];
  return r.w != null && (y = y || d <= 1 && ["w"] || d < r.w && ["ww", d]), y = y || u <= 1 && ["M"] || u < r.M && ["MM", u] || _ <= 1 && ["y"] || ["yy", _], y[2] = t, y[3] = +e > 0, y[4] = n, bu.apply(null, y);
}
function Ou(e) {
  return e === void 0 ? le : typeof e == "function" ? (le = e, !0) : !1;
}
function Du(e, t) {
  return Fe[e] === void 0 ? !1 : t === void 0 ? Fe[e] : (Fe[e] = t, e === "s" && (Fe.ss = t - 1), !0);
}
function Yu(e, t) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var r = !1, n = Fe, s, a;
  return typeof e == "object" && (t = e, e = !1), typeof e == "boolean" && (r = e), typeof t == "object" && (n = Object.assign({}, Fe, t), t.s != null && t.ss == null && (n.ss = t.s - 1)), s = this.localeData(), a = Mu(this, !r, n, s), r && (a = s.pastFuture(+this, a)), s.postformat(a);
}
var Gt = Math.abs;
function Re(e) {
  return (e > 0) - (e < 0) || +e;
}
function Wt() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = Gt(this._milliseconds) / 1e3, t = Gt(this._days), r = Gt(this._months), n, s, a, i, o = this.asSeconds(), l, u, d, _;
  return o ? (n = Z(e / 60), s = Z(n / 60), e %= 60, n %= 60, a = Z(r / 12), r %= 12, i = e ? e.toFixed(3).replace(/\.?0+$/, "") : "", l = o < 0 ? "-" : "", u = Re(this._months) !== Re(o) ? "-" : "", d = Re(this._days) !== Re(o) ? "-" : "", _ = Re(this._milliseconds) !== Re(o) ? "-" : "", l + "P" + (a ? u + a + "Y" : "") + (r ? u + r + "M" : "") + (t ? d + t + "D" : "") + (s || n || e ? "T" : "") + (s ? _ + s + "H" : "") + (n ? _ + n + "M" : "") + (e ? _ + i + "S" : "")) : "P0D";
}
var g = Nt.prototype;
g.isValid = gi;
g.abs = Ko;
g.add = eu;
g.subtract = tu;
g.as = nu;
g.asMilliseconds = qn;
g.asSeconds = su;
g.asMinutes = au;
g.asHours = iu;
g.asDays = ou;
g.asWeeks = uu;
g.asMonths = lu;
g.asQuarters = fu;
g.asYears = du;
g.valueOf = cu;
g._bubble = ru;
g.clone = hu;
g.get = mu;
g.milliseconds = yu;
g.seconds = _u;
g.minutes = pu;
g.hours = vu;
g.days = gu;
g.weeks = ku;
g.months = wu;
g.years = Su;
g.humanize = Yu;
g.toISOString = Wt;
g.toString = Wt;
g.toJSON = Wt;
g.locale = An;
g.localeData = En;
g.toIsoString = q(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  Wt
);
g.lang = Cn;
m("X", 0, 0, "unix");
m("x", 0, 0, "valueOf");
h("x", Yt);
h("X", Zs);
M("X", function(e, t, r) {
  r._d = new Date(parseFloat(e) * 1e3);
});
M("x", function(e, t, r) {
  r._d = new Date(v(e));
});
c.version = "2.30.1";
Ys(Y);
c.fn = f;
c.min = yi;
c.max = _i;
c.now = pi;
c.utc = ae;
c.unix = $o;
c.months = qo;
c.isDate = nt;
c.locale = Se;
c.invalid = bt;
c.duration = ee;
c.isMoment = K;
c.weekdays = Bo;
c.parseZone = Zo;
c.localeData = ye;
c.isDuration = ct;
c.monthsShort = Jo;
c.weekdaysMin = Xo;
c.defineLocale = br;
c.updateLocale = $a;
c.locales = Za;
c.weekdaysShort = Qo;
c.normalizeUnits = J;
c.relativeTimeRounding = Ou;
c.relativeTimeThreshold = Du;
c.calendarFormat = Hi;
c.prototype = f;
c.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
const Pu = Qn(void 0), Eu = ({
  children: e,
  state: t,
  initialMessages: r,
  adapter: n,
  events: s,
  storageKey: a,
  onFeedback: i
}) => {
  const [o, l] = oe.useState(r ?? []), [u, d] = oe.useState(!1), [_, y] = oe.useState(), [w, S] = oe.useState(t.maximize ?? !0), [D, H] = oe.useState(""), A = oe.useRef(null), I = rs(), W = ns(), C = (T) => {
    d(!0);
    const j = {
      id: `message-${Jt(14)}`,
      timestamp: c().unix(),
      message: T,
      role: "user",
      type: "text"
    };
    l((V) => [...V, j]);
  };
  oe.useEffect(() => {
    a && o.length > 0 && sessionStorage.setItem(a, JSON.stringify(o)), A.current && A.current.focus();
  }, [o.length, a]);
  const B = Ft((T) => {
    const O = o.find((L) => L.id === T);
    if (!O) return;
    const j = O.feedback === 1 ? 0 : 1, V = o.map((L) => L.id === T ? {
      ...L,
      feedback: j
    } : L);
    l(V), i?.(T, O.message.toString(), j), a && V.length > 0 && sessionStorage.setItem(a, JSON.stringify(V));
  }, [o, i, a]), ke = Ft((T) => {
    const O = o.find((L) => L.id === T);
    if (!O) return;
    const j = O.feedback === -1 ? 0 : -1, V = o.map((L) => L.id === T ? {
      ...L,
      feedback: j
    } : L);
    l(V), i?.(T, O.message.toString(), j), a && V.length > 0 && sessionStorage.setItem(a, JSON.stringify(V));
  }, [o, i, a]), be = Ft((T, O, j = "assistant", V) => {
    if (!O) return;
    const L = {
      id: T,
      timestamp: c().unix(),
      message: O,
      role: j,
      agent: V,
      type: "text"
    };
    return l(($e) => [...$e, L]), W.speak(O), d(!1), L;
  }, [W]), Me = (T) => {
    S(T);
  }, ot = () => {
    alert("Close"), t.onClose?.();
  };
  return oe.useEffect(() => {
    I.transcript && (t.sendOnSpeech ? C(I.transcript) : H(I.transcript));
  }, [I.transcript, t.sendOnSpeech]), oe.useEffect(() => {
    const T = o[o.length - 1], O = T?.role === "user";
    async function j() {
      const V = document.querySelector(".chatbot-body"), L = document.querySelector("#streaming > .message-wrapper > .message"), $e = `message-${Jt(14)}`;
      let Rr = "";
      const Jn = {
        next: (te, Wr) => {
          if (Wr && y(Wr), Rr += te, L) {
            const Bn = /* @__PURE__ */ Fr(Xn, { className: "message assistant", remarkPlugins: [Kn], rehypePlugins: [es], children: Rr });
            L.innerHTML = ts(Bn), V?.scrollTo(0, V.scrollHeight);
          }
        },
        complete: () => {
          d(!1), y(void 0);
        },
        error: (te) => {
          console.error(te), be($e, te, "system");
        },
        system: (te) => {
          console.log("System: ", te), be($e, te, "system");
        },
        history: o
      }, ut = await n(T.message, Jn, {
        history: o
      });
      if (s?.onMessageSent?.(T.message), ut) {
        const te = be(ut.messageId ?? $e, ut.message, "assistant", ut.sender);
        te && s?.onMessageReceived?.(te);
      }
    }
    u && O && j();
  }, [s, u]), /* @__PURE__ */ Fr(Pu.Provider, { value: {
    conversations: o,
    send: C,
    receive: be,
    isProcessing: u,
    agent: _,
    like: B,
    dislike: ke,
    prompt: D,
    setPrompt: H,
    maximize: w,
    onSizeChange: Me,
    onClose: ot,
    inputRef: A,
    speech: I,
    transcription: W
  }, children: e });
};
export {
  Pu as C,
  Eu as a,
  c as h
};
